import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import moment from 'moment';
import 'moment-timezone';

import AccountNumberAutoSuggests from '../common/accountNumberAutoSuggestsAvailPricing';
import BackOrdersAvailable from './updateBookedOrderBackOrders';

/* Dialogs */
import PriceSourceOverlayDialog from '../../dialogs/priceSourceOverlayDialog';
import ReplaceProductOverlayDialog from '../../dialogs/replaceProductOverlayDialog';
import UpgradeProductOverlayDialog from '../../dialogs/upgradeProductOverlayDialog';
import SubstituteProductOverlayDialog from '../../dialogs/substituteProductOverlayDialog';
import SelectPriceSourceOverlayDialog from '../../dialogs/selectPriceSourceOverlayDialog';
import AddServicesOverlayDialog from '../../dialogs/addServicesOverlayDialog';
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';
import InvalidSalesAgreementOverlayDialog from '../../dialogs/invalidSalesAgreementOverlayDialog';
import ChangeShippingMethodOverlayDialog from '../../dialogs/changeShippingMethodOverlayDialog';
import ChangeRequestedDeliveryDateOverlayDialog from '../../dialogs/changeRequestedDeliveryDateOverlayDialog';

/* Actions */
import {
	deleteOrderDetails,
	saveDeletedOrderProductsDetails,
	getPIMItemInfo,
	createNewOrder,
	checkPricesForSearchResult,
	decliningBalance,
	updateBookedOrder,
	saveUpdateBookedOrderConfirmationPageData,
	checkServicePrices,
	getOrderableServices,
	addToCart,
	saveToCart,
	saveBackOrders,
	saveBulkOrdersHold,
	saveOrderableServices,
	getOrderDetails,
	getSearchKeywordSuggestionList,
	getDeliveryCalendar
} from '../../../redux/actions';

import { DATE_TIME_FORMAT } from '../../common/messageConstants';

class updateBookedOrderForm extends Component {

	constructor(props) {
		super(props);
		this.state = {
			invalidPONumberMessage: 'PO number cannot include  `,~, | , * , >, <,  or /',
			errorMessage: '',
			selectedPriceSource: null,
			updateBookedOrderDetails: null,
			selectedPriceSourceForUpdate: '',
			reduceQtyOverPackQuantityState: null,
			showGenericOverlayDialog: false,
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',
			searchKeywordItem: [],
			showPriceSourceOverlayDialog: false,
			showSelectPriceSourceOverlayDialog: false,
			showSubstituteProductOverlayDialog: false,
			showReplaceProductOverlayDialog: false,
			showInvalidSalesAgreementOverlayDialog: false,
			showUpgradeProductOverlayDialog: false,
			showCancelEntireOrderConfirmationOverlaydialog: false,
			showChangeShippingMethodOverlayDialog: false,
			showChangeRequestedDeliveryDateOverlayDialog: false,

			showBackOrders: false,

			showAddServicesOverlayDialog: false,
			availableServices: null,

			products: [],

			isSDS_LOC: false,
			isSDS_will_call_loc: false,

			anyHoldBackOrderItem: false,
			anyReservationTransferHold: false,
			poNumberValue:'',
			deliveryPhoneValue:'',
			deliveryInstructionsValue:''
		};
		this.handleDialog = this.handleDialog.bind(this);
		this.validateSubstituteCriteria = this.validateSubstituteCriteria.bind(this);
		this.getDecliningBalanceData = this.getDecliningBalanceData.bind(this);
		this.updateOrderPoints = this.updateOrderPoints.bind(this);
		this.resetSelectedSKU = this.resetSelectedSKU.bind(this);
		this.manageAvailableServices = this.manageAvailableServices.bind(this);
		this.getZipCode = this.getZipCode.bind(this);
		this.makeServiceCallAddtoCart = this.makeServiceCallAddtoCart.bind(this);
		this.makeServiceCallCreateNewOrder = this.makeServiceCallCreateNewOrder.bind(this);
		this.callbackAFterParallelCall = this.callbackAFterParallelCall.bind(this);
		this.checkIfStateIsAk = this.checkIfStateIsAk.bind(this);
		this.getShippingAddressZipCode = this.getShippingAddressZipCode.bind(this);
		this.getShippingAddressState = this.getShippingAddressState.bind(this);
		this.isScheduledArrivalDateIsGreaterThan8Days = this.isScheduledArrivalDateIsGreaterThan8Days.bind(this);
	}

	updateOrderPoints() {
		const self = this;
		const { items } = self.state.updateBookedOrderDetails;
		let orderPoints = 0.00;
		let orderWeight = 0.00;
		items && items.forEach(item => {
			if(item.action !== 'Hold Backorder' && item.action !== 'cancel' && item.action !== 'split') {
				if(item.whenAdded === 'new') {
					orderPoints += parseFloat(item.perItemPointValue) * item.quantity;
					orderWeight += parseFloat(item.perItemWeight) * item.quantity;
				} else if(item.updatedQuantity) {
					orderPoints += parseFloat(item.perItemPointValue) * item.updatedQuantity;
					orderWeight += parseFloat(item.perItemWeight) * item.updatedQuantity;
				} else {
					if(item.perItemPointValue) {
						orderPoints += parseFloat(item.perItemPointValue) * item.quantity;
					}
					if(item.perItemWeight) {
						orderWeight += parseFloat(item.perItemWeight) * item.quantity;
					}
				}
			}
		});
		const { backOrders } = self.props.state.order;
		if(backOrders && backOrders.responseObject) {
			backOrders.responseObject.forEach((item, index) => {
				item.orderDetail.orderLine.forEach((i, index) => {
					if (i.selected) {
						orderPoints += parseFloat(i.perItemPointValue) * i.orderedQty;
						orderWeight += parseFloat(i.perItemWeight) * i.orderedQty;
					}
				});
			});
		}
		const { bulkOrdersHold } = self.props.state.order;
		if(bulkOrdersHold && bulkOrdersHold.responseObject) {
			bulkOrdersHold.responseObject.forEach((item, index) => {
				item.orderDetail.orderLine.forEach((i, index) => {
					if (i.selected) {
						orderPoints += parseFloat(i.perItemPointValue) * i.reservedQty;
						orderWeight += parseFloat(i.perItemWeight) * i.reservedQty;
					}
				});
			});
		}
		self.setState({
			updateBookedOrderDetails: {
				...self.state.updateBookedOrderDetails,
				orderPoints: parseFloat(orderPoints).toFixed(2),
				orderWeight: parseFloat(orderWeight).toFixed(2),
			}
		});
	}

	onChangeUpdateParamForNewProduct(index, event) {
		const self = this,
			name = event.target.name,
			value = event.target.value;
		let { products } = self.state;
		products[index][name] = value;
		self.setState({
			products: JSON.parse(JSON.stringify(products)),
		});
	}

	onChangeUpdateParam(index, event) {
		const self = this,
			name = event.target.name,
			value = event.target.name === 'poNumber' ? event.target.value.toUpperCase() : event.target.value;
		let { updateBookedOrderDetails }= self.state;
		if(name == "action" && value == "reduceQty"){
			self.props.getSearchKeywordSuggestionList(`requestType=getItems&keyword=${updateBookedOrderDetails.items[index].item}&count=5`, (response) => {
				updateBookedOrderDetails.items[index]["overpackQuantityRequired"]=response.responseObject[0].overpackQuantityRequired;
				updateBookedOrderDetails.items[index]["packageQuantity"]=response.responseObject[0].packageQuantity;
				self.setState({
					updateBookedOrderDetails: JSON.parse(JSON.stringify(updateBookedOrderDetails))
				})

			});
		}
		updateBookedOrderDetails.items[index][name] = value;
		if(name === 'poNumber') {
			updateBookedOrderDetails.items[index].invalidPONumberItemLevel = false;
		}
		if(name === 'action') {
			delete updateBookedOrderDetails.items[index].quantityGTError;
			if (value === 'substitute') {
				const item = updateBookedOrderDetails.items[index];
				self.setState({
					showSubstituteProductOverlayDialog: false,
					selectedSKU: item.item,
					selectedSKUIndex: index,
					substituteSKUData: null,
					selectedRDD: moment(updateBookedOrderDetails.requestedDeliveryDate),
				}, () => {
					const skuList = item.substituteSKUs.map(item => ({sku: item, itemType: 'M'}));
					if(skuList.length > 0) {
						self.getAllProductsData(skuList, item.quantity, item.item, item.agreementNumber, data => {
							const { availabilityData, pricingData, pimData } = self.state;
							if(availabilityData.length > 0) {
								const substituteSKUData = [];
								let attributeName = "geego_top_load";
								self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
									if(!resp) {
										attributeName = "geego_no_top_load";
									}
									availabilityData.forEach(item => {
										const availability = item;
										let salesPriceData = _.find(pricingData, itm => {
											return itm.sku === availability.sku
										});
										const pimItemData = _.find(pimData, {item_number: availability.sku});
										if(availability && salesPriceData && pimItemData) {
											const hasReplacement = pimItemData && pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Superseded") !== -1?true:false;
											const replacementSKUs = hasReplacement?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Superseded"):[];
											const hasSubstitute = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Substitute") !== -1?true:false;
											const substituteSKUs = hasSubstitute?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Substitute"):[];
											const hasUpgrade = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Up-Sell") !== -1?true:false;
											const upgradeSKUs = hasUpgrade?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Up-Sell"):[];
											const isFedexable = pimItemData.geego_fedexable === "Y" ? true : false;
											let uncrateInd = "N";
											if(pimItemData.geego_uncrateind) {
												let geego_uncrateind = pimItemData.geego_uncrateind;
												const { selectedAccountsAllPriceSources } = self.props.state.user;
												const { selectedPriceSource } = self.state;
												const record  = selectedAccountsAllPriceSources && _.find(selectedAccountsAllPriceSources.responseObject, {AGREEMENT_NUMBER: selectedPriceSource.AGREEMENT_NUMBER});
												if(record) {
													uncrateInd = record[geego_uncrateind] === "Y"?"Y":"N";
												}
											}
											substituteSKUData.push({
												item: availability.sku,
												itemDescription: pimItemData.item_description,
												availability: availability.availableQty,
												itemType: "M",
												overpackQuantityRequired:"",
												packageQuantity:"",
												eta: availability.etaDate,
												price: salesPriceData.originalPrice,
												originalPrice: salesPriceData.originalPrice,
												relatedServices: self.props.prepareBagItems(salesPriceData),
												pointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * 1) : 0.00,
												weight: self.props.getOrderWeightFromPimData(pimItemData, 1),
												hasReplacement,
												hasSubstitute,
												hasUpgrade,
												replacementSKUs,
												substituteSKUs,
												upgradeSKUs,
												isFedexable,
												uncrateInd
											});
										}
									});
									if(substituteSKUData.length > 0) {
										self.setState({
											showSubstituteProductOverlayDialog: true,
											substituteSKUData
										});
									} else {
										self.setState({
											showSubstituteProductOverlayDialog: true,
											substituteSKUData: []
										});
									}
								});
							} else {
								self.setState({
									showSubstituteProductOverlayDialog: true,
									substituteSKUData: []
								});
							}
						})
					} else {
						self.setState({
							showSubstituteProductOverlayDialog: true,
							substituteSKUData: []
						});
					}
				})
			} else if(value !== 'reduceQty') {
				delete updateBookedOrderDetails.items[index].updatedQuantity;
				delete updateBookedOrderDetails.items[index].updatedQuantityError;
			} else {
				updateBookedOrderDetails.items[index].updatedQuantity = updateBookedOrderDetails.items[index].quantity;
				updateBookedOrderDetails.items[index].updatedQuantityError = '';
			}
		} else if(name === 'updatedQuantity') {
			updateBookedOrderDetails.items[index].updatedQuantityError = '';
			delete updateBookedOrderDetails.items[index].quantityGTError;
		} else if(name === 'quantity') {
			updateBookedOrderDetails.items[index].quantityError = '';
			delete updateBookedOrderDetails.items[index].quantityGTError;
		}
		self.setState({
			updateBookedOrderDetails: JSON.parse(JSON.stringify(updateBookedOrderDetails)),
			bkpUpdateBookedOrderDetails: JSON.parse(JSON.stringify(updateBookedOrderDetails)),
		}, () => {
			self.updateOrderPoints();
		});
	}

	onChangeUpdateParamHeaderFields(event) {
        const self = this;
		const paramName = event.target.name;
		self.setState({
			poNumberValue: paramName === 'poNumber' ? event.target.value.toUpperCase() : self.state.poNumberValue,
			deliveryPhoneValue:paramName === 'deliveryPhone' ? event.target.value.toUpperCase() : self.state.deliveryPhoneValue,
			deliveryInstructionsValue: paramName === 'deliveryInstructions' ? event.target.value.toUpperCase() : self.state.deliveryInstructionsValue
		})
    }
	
	checkIfAlreadyAdded(items, orderNumber, item, lineNo) {
		let flag = false;
		if(items.find(itm => itm.item === item && itm.originalOrderNumber === orderNumber && itm.lineNo === lineNo)) {
			flag = true;
		}
		return flag;
	}

	checkLocTypeAvailable(loctype) {
		const self = this,
			{ shippingAddress } = self.state.updateBookedOrderDetails,
			zipCode = shippingAddress.zip.split('-')[0];
		let shippingAddressDetail = _.find(self.props.state.user.shippingAddressDetailsListWithZipCode, {zipCode: zipCode});
		let data = shippingAddressDetail && _.find(shippingAddressDetail.details, ["loctype", loctype]);
		if(data && data.agentid && data.agentid !== "NA") {
			return true;
		} else {
			return false;
		}
	}
	
	anyRestrictedItemsAdded(callback) {
		const self = this;
		const restrictedItems = self.state.updateBookedOrderDetails.items.filter(item => self.props.isAnyModelIsRestrictedInSelectedAccount(item));
		if (restrictedItems.length === 0) {
			callback();
		}
	}

	handleSaveAndContinue(event) {
		event.preventDefault();
		const self = this,
			{ updateBookedOrderDetails, products, disallowSAErrorMessage } = self.state;
		if (disallowSAErrorMessage) {
			return;
		}
		let formError = false;
		let allItemsAreHoldBackOrderORCancelled = true;
		let isSplitDeliverySelected = false;
		let isAnyHoldBackOrderItem = false;
		let isAnyMServiceSelectSplitDelivery = false;
		updateBookedOrderDetails.items.forEach((item) => {
			if (item.whenAdded !== 'new' && item.action === 'Split Delivery') {
				isSplitDeliverySelected = true;
				if (self.isMService(item.internalItem || item.item)) {
					isAnyMServiceSelectSplitDelivery = true;
				}
			}
			if (item.whenAdded !== 'new' && item.action === 'Hold Backorder') {
				isAnyHoldBackOrderItem = true;
			}
			item.poNumber = item.poNumber.trim().toUpperCase();
			if(item.whenAdded !== 'new' && !(item.action === 'Hold Backorder' || item.action === 'cancel')) {
				allItemsAreHoldBackOrderORCancelled = false;
			}
			if(item.action === 'reduceQty' && item.updatedQuantity === '') {
				item.updatedQuantityError = 'error';
				item.quantityGTError = '';
				formError = true;
			}
			if(item.action === 'reduceQty' && parseInt(item.updatedQuantity, 10) > parseInt(item.quantity, 10)) {
				item.updatedQuantityError = 'error';
				item.quantityGTError = 'Quantity should not be greater than ' + item.quantity;
				formError = true;
			}
			if(item.whenAdded === 'new' &&
				(
					!item.quantity ||
					item.quantity === '0' ||
					(parseInt(item.quantity, 10) > parseInt(item.availability, 10) &&
						!moment(item.eta).isBefore(moment(self.props.pickTheDateFromString(updateBookedOrderDetails.requestedDeliveryDate)))
					)
				)
			) {
				item.quantityError = 'error';
				formError = true;
			}
			if(item.whenAdded === 'new' && item.actionError) {
				item.actionError = 'error';
				formError = true;
			}
			if(item.lifeCyclePhase === "Near End of Life"){
				item.actionError = 'error';
				formError = true;
			}
		});

		products.forEach((item) => {
			if(item) {
				if(item.modelNotAvailableError || !item.productDetails || !item.productDetails.status || (item.productDetails && (!item.productDetails.availableQty || item.productDetails.availableQty === '0'))) {
					item.error = 'error';
					formError = true;
				} else {
					item.error = '';
				}
			}
		})
		updateBookedOrderDetails.poNumber = updateBookedOrderDetails.poNumber.trim().toUpperCase();
		const {shippingAddress} = self.props.state.order.orderDetails.responseObject ;
		const {state, zip} = shippingAddress;
		const zipValue = zip.split("-")[0];
		self.props.getShippingAddressesDetails(zipValue, false, 'adc_loc', resp => {
			self.setState({
				updateBookedOrderDetails: JSON.parse(JSON.stringify(updateBookedOrderDetails)),
				isSDS_LOC: self.checkLocTypeAvailable('sds_loc'),
				isSDS_will_call_loc: self.checkLocTypeAvailable('sds_will_call_loc'),
				isSplitDeliverySelected,
				isAnyHoldBackOrderItem,
				isAnyMServiceSelectSplitDelivery
			}, () => {
				const { backOrders } = self.props.state.order;
				const selectedAccountsAllPriceSources = self.props.state.user.selectedAccountsAllPriceSources;
				const backOrdersSelectedItems = [];
				if(backOrders && backOrders.responseObject) {
					backOrders.responseObject.forEach((item, index) => {
						item.orderDetail.orderLine.forEach((i, indx) => {
							if(i.orderedQtyError || i.orderedQtyRequiredError || i.updatedAgreementNumberError) {
								formError = true;
								window.scrollTo(0, self.getElementOffset(`backOrders${index}${indx}`));
							}
							if (i.selected && !self.checkIfAlreadyAdded(updateBookedOrderDetails.items, item.orderHeader.orderNumber, i.item, `${i.lineNum}.${i.shipmentNum}`)) {
								const priceSourceDetails = i.updatedAgreementNumber && self.props.state.user.selectedAccountsAllPriceSources.responseObject.find(itm => itm.AGREEMENT_NUMBER.toString() === i.updatedAgreementNumber.toString());
								if(!i.updatedAgreementNumber || !selectedAccountsAllPriceSources.responseObject.find(itm => itm.AGREEMENT_NUMBER.toString() === i.updatedAgreementNumber.toString())) {
									formError = true;
									i.updatedAgreementNumberError = 'error';
								}
								const newItem = {
									action: 'new',
		   							boAvailableItem: 'Y',
									agreementNumber: i.updatedAgreementNumber,
									modifiers: i.modifiers,
									agreementType: priceSourceDetails && priceSourceDetails.AGREEMENT_TYPE,
									item: i.item,
									price: i.price,
									quantity: i.orderedQty,
									originalOrderNumber: i.originalOrderNumber,
									itemType: i.itemType,
									pointValue: i.pointValue,
									perItemPointValue: i.perItemPointValue,
									geego_cust_acct: i.geego_cust_acct,
									perItemWeight: i.perItemWeight,
									lineNo: `${i.lineNum}.${i.shipmentNum}`,
									poNumber: i.keepOriginalPO === 'Y' ? i.poNumber : '',
									buyerLineNo: i.keepOriginalPO === 'Y' ? i.buyerLineNum : '',
									orderLineId: i.orderLineId,
									pricingDate: i.pricingDate
								};
								if(i.keepOriginalPrice === 'Y') {
									newItem.pricingDate = self.props.pickTheDateFromString(i.pricingDate);
								}else{
									let todayDate = new Date();
									let date=parseInt(todayDate.getMonth()+1) +"/"+todayDate.getDate() + "/"+todayDate.getFullYear();
									newItem.pricingDate = self.props.pickTheDateFromString(date);
								}
								backOrdersSelectedItems.push(newItem);
							}
						});
					});
					self.props.saveBackOrders(backOrders);
				}

				const { bulkOrdersHold } = self.props.state.order;
				if(bulkOrdersHold && bulkOrdersHold.responseObject) {
					bulkOrdersHold.responseObject.forEach((item, index) => {
						item.orderDetail.orderLine.forEach((i, indx) => {
							if(i.reservedQtyError || i.reservedQtyRequiredError || i.updatedAgreementNumberError) {
								formError = true;
								window.scrollTo(0, self.getElementOffset(`bulkOrdersHold${index}${indx}`));
							}
							if (i.selected && !self.checkIfAlreadyAdded(updateBookedOrderDetails.items, item.orderHeader.orderNumber, i.item, `${i.lineNum}.${i.shipmentNum}`)) {
								const priceSourceDetails = i.agreementNumber && self.props.state.user.selectedAccountsAllPriceSources.responseObject.find(itm => itm.AGREEMENT_NUMBER.toString() === i.agreementNumber.toString());
								if(!i.updatedAgreementNumber || !selectedAccountsAllPriceSources.responseObject.find(itm => itm.AGREEMENT_NUMBER.toString() === i.updatedAgreementNumber.toString())) {
									formError = true;
									i.updatedAgreementNumberError = 'error';
								}
								const newItem = {
									action: 'new',
		   							boAvailableItem: 'Y',
									agreementNumber: i.updatedAgreementNumber,
									modifiers: i.modifiers,
									agreementType: priceSourceDetails && priceSourceDetails.AGREEMENT_TYPE,
									item: i.item,
									price: i.price,
									quantity: i.reservedQty,
									originalOrderNumber: i.originalOrderNumber,
									itemType: i.itemType,
									pointValue: i.pointValue,
									perItemPointValue: i.perItemPointValue,
									geego_cust_acct: i.geego_cust_acct,
									perItemWeight: i.perItemWeight,
									lineNo: `${i.lineNum}.${i.shipmentNum}`,
									poNumber: i.keepOriginalPO === 'Y' ? i.poNumber : '',
									buyerLineNo: i.keepOriginalPO === 'Y' ? i.buyerLineNum : '',
									orderLineId: i.orderLineId,
									pricingDate: i.pricingDate,
								};
								if(i.keepOriginalPrice === 'Y') {
									newItem.pricingDate = self.props.pickTheDateFromString(i.pricingDate);
								}
								backOrdersSelectedItems.push(newItem);
							}
						});
					});
					self.props.saveBulkOrdersHold(bulkOrdersHold);
				}
				if(!formError) {
					const { anyHoldBackOrderItem } = self.state;
					const { deliveryMethod, orderPoints, orderWeight } = updateBookedOrderDetails;
					if(
						((deliveryMethod === 'SDS Will Call' || deliveryMethod === 'SDS Delivery' || deliveryMethod === 'SDS Delivery Next Day') && orderPoints > 26) ||
						(deliveryMethod === 'ADC LTL' && (orderPoints > 38 || orderWeight > 12000))
					) {
						self.setState({
							genericDialogHeading: "Action",
							genericDialogText: "Order Points exceeds the limit for this shipment.  Please cancel some items before adding to this order.",
							modalButtons: 'ok'
						}, () => {
							self.handleDialog("GenericOverlayDialog", true);
						});
					}
					// If all items are cancelled or user selected hold back order for the older items only
					// No need to check for order points for ADC Truckload
					else if (allItemsAreHoldBackOrderORCancelled && deliveryMethod === 'ADC Truckload') {
						self.continueFurther(updateBookedOrderDetails, backOrdersSelectedItems);
					}
					// if method is ADC Truckload and order points is less then 26
					// Need to exclude velocity customers
					else if (!anyHoldBackOrderItem && deliveryMethod === 'ADC Truckload' && orderPoints < 26) {
						if(self.props.isVelocityCustomer) {
							self.continueFurther(updateBookedOrderDetails, backOrdersSelectedItems);
						} else if(!anyHoldBackOrderItem) {
							self.setState({
								genericDialogHeading: "Action",
								genericDialogText: "Order Points do not qualify for an ADC Truckload shipment.  Please add some available items to proceed.",
								modalButtons: 'ok'
							}, () => {
								self.handleDialog("GenericOverlayDialog", true);
							});
						}
					}
					// if method is ADC Truckload and order points > 126.5
					// Need to exclude velocity customers
					else if(!anyHoldBackOrderItem && deliveryMethod === 'ADC Truckload' && orderPoints > 126.5) {
						if(self.props.isVelocityCustomer) {
							self.continueFurther(updateBookedOrderDetails, backOrdersSelectedItems);
						} else {
							self.setState({
								genericDialogHeading: "Action",
								genericDialogText: "Order Points exceeds the limit for this shipment.  Please cancel some items before adding to this order.",
								modalButtons: 'ok'
							}, () => {
								self.handleDialog("GenericOverlayDialog", true);
							});
						}
					} else {
						self.continueFurther(updateBookedOrderDetails, backOrdersSelectedItems);
					}
				}
			});
		},true,state);
	}

	continueFurther(updateBookedOrderDetails, backOrdersSelectedItems) {
		const self = this;
		let orderNumbers = [];
		// check if already data exists in state else add that order number to orderNumbers list
		backOrdersSelectedItems.forEach(item => {
			item.itemDescription = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "itemDescription");
			item.modifiers = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "modifiers");
			const shipmentNumber = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "shipmentNumber");
			const lineNo = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "lineNo");
			item.lineNo = lineNo + '.' + (shipmentNumber || 1);
			if (shipmentNumber === "" || lineNo === "" || item.modifiers === "" || item.itemDescription === "") {
				orderNumbers.push(item.originalOrderNumber);
			}
		});
		// make calls to get order details
		orderNumbers = _.uniq(orderNumbers);
		if (orderNumbers.length) {
			self.props.getOrderDetailsInParallelBatches(orderNumbers, () => {
				// check if already data exists in state else add that order number to orderNumbers list
				backOrdersSelectedItems.forEach(item => {
					item.itemDescription = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "itemDescription");
					item.modifiers = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "modifiers");
					const shipmentNumber = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "shipmentNumber");
					const lineNo = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "lineNo");
					item.lineNo = lineNo + '.' + (shipmentNumber || 1);
					item.originalItem = self.props.getDataFromParallelCall(item.orderLineId, item.originalOrderNumber, "originalItem");
				});
				self.updateItemsAsPerUpdatedBackOrdersSelectedItems(updateBookedOrderDetails, backOrdersSelectedItems);
			});
		} else {
			self.updateItemsAsPerUpdatedBackOrdersSelectedItems(updateBookedOrderDetails, backOrdersSelectedItems);
		}
	}

	updateItemsAsPerUpdatedBackOrdersSelectedItems(updateBookedOrderDetails, backOrdersSelectedItems) {
		const self = this;
		self.anyRestrictedItemsAdded(() => {
			// prepare list of updated fields
			const { updateBookedOrderDetailsBkp } = self.state;
			let updatedField = [];
			updateBookedOrderDetails.items.forEach((item, index) => {
				const existingItem = updateBookedOrderDetailsBkp.items[index];
				if(existingItem && existingItem.poNumber !== item.poNumber) {
					updatedField.push('PO');
				}
				const priceSourceDetails = item.agreementNumber && self.props.state.user.selectedAccountsAllPriceSources.responseObject.find(itm => itm.AGREEMENT_NUMBER.toString() === item.agreementNumber.toString());
				if(priceSourceDetails) {
					item.agreementType = priceSourceDetails.AGREEMENT_TYPE;
				}
				if(item.whenAdded !== 'new' && item.updatedQuantity) {
					if(item.quantity !== item.updatedQuantity) {
						updatedField.push('QUANTITY');
					}
					item.quantity = item.updatedQuantity;
				}
				item.originalAction = item.action;
				item.lineType = item.action;
				if(item.whenAdded === 'new') {
					item.action = 'new';
					updatedField.push('NEW');
				} else if(item.action === 'cancel' || item.action === 'split' || item.action === 'Hold Backorder') {
					item.action = 'cancel';
					updatedField.push(item.action.toUpperCase());
				} else {
					item.action = 'update';
					if(item.originalAction) {
						updatedField.push(item.originalAction.toUpperCase());
					}
				}
			});
			updateBookedOrderDetails.agreementType = self.state.selectedPriceSource.AGREEMENT_TYPE;
			if(backOrdersSelectedItems) {
				backOrdersSelectedItems.forEach(itm => {
					updatedField.push('NEW');
				});
				updateBookedOrderDetails.items = updateBookedOrderDetails.items.concat(backOrdersSelectedItems);
			}
			updatedField = _.uniq(updatedField);
			self.props.saveUpdateBookedOrderConfirmationPageData(updateBookedOrderDetails);
			// Make service call and show confirmation page logic goes here.
			const { userDetails } = self.props.state.user;
			const payload = {
				...updateBookedOrderDetails,
				createdById: userDetails.sso,
				createdBy: `${userDetails.firstName} ${userDetails.lastName}`,
				poNumber: self.state.poNumberValue,
				deliveryPhone:self.state.deliveryPhoneValue,
				deliveryInstructions:self.state.deliveryInstructionsValue
			};
			// Fire gtm tag for cancel order click only
			self.props.fireGTMTag('Update Booked Save and Continue', {
				orderNumber: payload.orderNumber,
				updatedField: updatedField.join(', '),
			});
			self.setState({
				updateBookedOrderCallCompleted: false,
				splitDeliveryCallCompleted: false,
				splittedCallCompleted: false,
				holdBackOrderCallCompleted: false,
				showChangeShippingMethodOverlayDialog: false,
				showChangeRequestedDeliveryDateOverlayDialog: false,
				payload
			}, () => {
				// If the user selects Hold Backorder for one item and Split Delivery for one item, please display this message.
				if (self.state.isAnyHoldBackOrderItem && self.state.isSplitDeliverySelected) {
					self.setState({
						genericDialogHeading: "Action",
						genericDialogText: "Please select either Hold Backorder or Split Delivery. Only one new order can be created at a time.",
						modalButtons: 'ok'
					}, () => {
						self.handleDialog("GenericOverlayDialog", true);
					});
				} else if (self.state.isSplitDeliverySelected) {
					self.handleDialog('ChangeShippingMethodOverlayDialog', true);
				} else {
					self.continueWithPreparedPayload();
				}
			});
		});
		
	}

	continueWithPreparedPayload() {
		const self = this;
		const { payload } = self.state;
		if (payload.items.find(item => item.action === 'new')) {
			let decliningLineNo = 1;
			payload.items.forEach((item, index) => {
				if(item.action === 'new') {
					item.decliningLineNo = decliningLineNo++;
				}
			});
		if(self.props.state.order.decliningBalanceNewAccountClassification.indexOf(self.props.customerClassCodeOfSelectedAccount.toLowerCase()) === -1){
				self.getDecliningBalanceData(payload.items, updatedItems => {
					payload.items = updatedItems;
					// update update booked order details and back orders selected items
					self.makeUpdateBookedOrderServiceCall(payload);
				});
			}else{
				self.makeUpdateBookedOrderServiceCall(payload);
			}
		} else {
			self.makeUpdateBookedOrderServiceCall(payload);
		}
	}

	getDecliningBalanceData(items, callback) {
		const self = this;
		// declining balance service call
		const decliningBalancePayload = [];
		items.forEach((item, index) => {
			if ((item.itemType === 'M' || item.itemType === 'A' || item.itemType === 'S') && item.action === 'new') {
				decliningBalancePayload.push({
					customernumber: "",
					salesagreementnumber: parseInt(item.agreementNumber, 10),
					ordereditem: item.item,
					extendedamount: item.price * item.quantity,
					lineidentifier: item.decliningLineNo,
					orderedquantity: parseInt(item.quantity, 10)
				});
				if (item.relatedServices && item.relatedServices.length) {
					item.relatedServices.forEach((itm, ind) => {
						if (itm.itemType === 'S') {
							decliningBalancePayload.push({
								customernumber: "",
								salesagreementnumber: parseInt(item.agreementNumber, 10),
								ordereditem: itm.serviceId,
								extendedamount: itm.price * itm.quantity,
								lineidentifier: itm.decliningLineNo,
								orderedquantity: parseInt(itm.quantity, 10)
							});
						}
					});
				}
			}
		});
		if (decliningBalancePayload.length) {
			self.props.decliningBalance(decliningBalancePayload, response => {
				// Update tax details & declining balance details
				let decliningBalanceResponse = response;
				if (decliningBalanceResponse &&
					decliningBalanceResponse.status &&
					decliningBalanceResponse.responseObject &&
					decliningBalanceResponse.responseObject.declinebalinpdetails &&
					decliningBalanceResponse.responseObject.declinebalinpdetails.length
				) {
					decliningBalanceResponse = decliningBalanceResponse.responseObject.declinebalinpdetails;
				} else {
					decliningBalanceResponse = null;
				}
				// If the account classification is NOT in the list above, then check the PRICE_LIST_NAME for the SA for each order line. For any line where the PRICE_LIST_NAME starts with “QUOTE”, put the line on DB hold and display the user message.
				const { selectedAccountsAllPriceSources } = self.props.state.user;
				// set dbholdflag & holdcomments if we have response
				items.forEach((item, index) => {
					if((item.itemType === 'M' || item.itemType === 'A' || item.itemType === 'S') && item.action === 'new') {
						if (decliningBalanceResponse) {
							const decliningBalanceDetail = decliningBalanceResponse.find(record => record.lineidentifier === item.decliningLineNo.toString());
							if (decliningBalanceDetail) {
								item.dbholdflag = decliningBalanceDetail.dbholdflag;
								item.holdcomments = decliningBalanceDetail.holdcomments;
							}
							if(item.relatedServices && item.relatedServices.length) {
								item.relatedServices.forEach((itm, ind) => {
									if (itm.itemType === 'S') {
										const decliningBalanceDetail2 = decliningBalanceResponse.find(record => record.lineidentifier === (index.toString() + '.0' + ind.toString()));
										if (decliningBalanceDetail2) {
											itm.dbholdflag = decliningBalanceDetail2.dbholdflag;
											itm.holdcomments = decliningBalanceDetail2.holdcomments;
										}
									}
								});
							}
						} else if(self.props.state.order.decliningBalanceAccountClassifications.indexOf(self.props.customerClassCodeOfSelectedAccount.toLowerCase()) === -1) {
							const priceSourceDetails = selectedAccountsAllPriceSources.responseObject.find(itm => itm.AGREEMENT_NUMBER.toString() === item.agreementNumber.toString());
							if (priceSourceDetails && priceSourceDetails["PRICE_LIST_NAME"].indexOf('QUOTE') === 0) {
								item.dbholdflag = 'Y';
							}
						}
					}
				});
				callback && callback(items);
			});
		} else {
			callback && callback(items);
		}
	}

	makeUpdateBookedOrderServiceCall(payload) {
		const self = this;
		// update booked order service call
		
		//reverting 7511 changes from sprint-39 
		// const {items} = payload;
		// 	items.forEach((itm)=>{
		// 		if(itm.lineType === 'Split Delivery' && itm.attribute12 != null){
		// 			itm.originalItem = itm.attribute12;
		// 		}
		// 	})
		self.props.updateBookedOrder(payload, 'requestType=updateBookedOrder', response => {
			if(response.status) {
				if(response.responseObject) {
					self.setState({
						updateBookedOrderCallCompleted: true
					}, () => {
						self.callbackAFterParallelCall();
					});
				} else {
					const updateBookedOrderErrorOccured = [];
					const responseMessage = response.responseMessage.split(',');
					responseMessage.forEach((error, index) => {
						if(error) {
							updateBookedOrderErrorOccured.push(<span className={error.indexOf('Error') === -1 ? "green" : ""} key={index + 1}>{error}<br/></span>);
						}
					});
					self.setState({
						updateBookedOrderCallCompleted: true,
						updateBookedOrderDetails: {
							...self.state.updateBookedOrderDetails,
							updateBookedOrderErrorOccured,
							updateBookedOrderServiceFailed: true,
						}
					}, () => {
						self.props.saveUpdateBookedOrderConfirmationPageData(self.state.updateBookedOrderDetails);
						self.callbackAFterParallelCall();
					});
				}
			} else {
				const updateBookedOrderErrorOccured = [];
				updateBookedOrderErrorOccured.push(response.responseMessage);
				self.setState({
					updateBookedOrderCallCompleted: true,
					updateBookedOrderDetails: {
						...self.state.updateBookedOrderDetails,
						updateBookedOrderErrorOccured,
						updateBookedOrderServiceFailed: true,
					}
				}, () => {
					self.props.saveUpdateBookedOrderConfirmationPageData(self.state.updateBookedOrderDetails);
					self.callbackAFterParallelCall();
				});
			}
		});
		const { updateBookedOrderDetails } = self.state;
		// check if user has selected split option or not
		// if yes then need to make service call to add to cart and then redirect to confirmation page
		const splitedItem = updateBookedOrderDetails.items.filter(item => item.action === 'split');
		// check if user has selected split option or not
		// if yes then need to make service call to add to cart and then redirect to confirmation page
		const holdBackorderItem = updateBookedOrderDetails.items.filter(item => item.whenAdded !== 'new' && item.action === 'Hold Backorder');
		const { isSplitDeliverySelected } = self.state;
		if(splitedItem.length > 0 || holdBackorderItem.length > 0 || isSplitDeliverySelected) {
			self.setState({
				splittedCallCompleted: splitedItem.length === 0,
				holdBackOrderCallCompleted: holdBackorderItem.length === 0,
				splitDeliveryCallCompleted: !isSplitDeliverySelected,
			}, () => {
				if(splitedItem.length > 0) {
					// Add to cart logic
					const { selectedPriceSource } = self.state,
						{ cart } = self.props.state.cart,
						cartItems = cart && cart.responseObject && cart.responseObject.cartItems ? cart.responseObject.cartItems : [];
					splitedItem.forEach(itm => {
						cartItems.push({
							itemType: itm.orgItemType,
							item: itm.item,
							quantity: itm.quantity,
							itemDescription: itm.itemDescription,
							agreementNumber: selectedPriceSource.AGREEMENT_NUMBER,
							orderDate: self.props.pickTheDateFromString(updateBookedOrderDetails.orderDate),
							createdDate: moment().format(DATE_TIME_FORMAT),
							updatedDate: moment().format(DATE_TIME_FORMAT),
						});
					});
					self.makeServiceCallAddtoCart(cartItems, self.callbackAFterParallelCall);
				} else {
					self.callbackAFterParallelCall();
				}
				if (holdBackorderItem.length > 0) {
					const payload = {
						...updateBookedOrderDetails,
						fromPage: 'updatebookedorder'
					};
					self.makeServiceCallCreateNewOrder(payload, holdBackorderItem, true, self.callbackAFterParallelCall);
				} else {
					self.callbackAFterParallelCall();
				}
				if (isSplitDeliverySelected) {
					const payload = self.state.newPayload;
					self.makeServiceCallCreateNewOrder(payload, payload.items, false, self.callbackAFterParallelCall);
				} else {
					self.callbackAFterParallelCall();
				}
			});
		} else {
			self.setState({
				holdBackOrderCallCompleted: true,
				splittedCallCompleted: true,
				splitDeliveryCallCompleted: true,
			}, () => {
				self.callbackAFterParallelCall();
			});
		}
	}

	makeServiceCallCreateNewOrder(updateBookedOrderDetails, itemList, isBackOrderHold, callback) {
		const self = this;
		let orderTotal = 0.00;
		itemList.forEach(itm => {
			// if its split delivery
			if (!isBackOrderHold) {
				itm.item = itm.internalItem;
			}
			itm.requestedDeliveryDate = self.props.pickTheDateFromString(itm.requestedDeliveryDate);
			itm.pricingDate = self.props.pickTheDateFromString(itm.pricingDate);
			itm.shipDate = self.props.pickTheDateFromString(itm.shipDate);
			itm.suggestedShipDate = self.props.pickTheDateFromString(itm.suggestedShipDate);
			itm.invoiceDate = self.props.pickTheDateFromString(itm.invoiceDate);
			itm.scheduledShipDate = self.props.pickTheDateFromString(itm.scheduledShipDate);
			itm.scheduleArrivalDate = self.props.pickTheDateFromString(itm.scheduleArrivalDate);
			itm.plannedArrivalDate = self.props.pickTheDateFromString(itm.plannedArrivalDate);
			itm.actualFulfillmentDate = self.props.pickTheDateFromString(itm.actualFulfillmentDate);
			if (isBackOrderHold) {
				itm.onHold = 'Y';
			}
			if(itm.quantity && itm.price) {
				orderTotal += parseFloat(itm.quantity * itm.price);
			}
			itm.uncrateInd = itm.uncrateInd || itm.customUncrateInd || "";
		});
		const { userDetails } = self.props.state.user,
			{ shippingAddress } = updateBookedOrderDetails,
			zipCode = shippingAddress.zip.split('-')[0];
		let loctype = 'adc_loc';
		let state = shippingAddress.state;
		if (!isBackOrderHold) {
			if (updateBookedOrderDetails.deliveryMethod === 'SDS Delivery') {
				loctype = 'sds_loc';
			} else if (updateBookedOrderDetails.deliveryMethod === 'SDS Will Call') {
				loctype = 'sds_will_call_loc';
			}
		}
		self.props.getShippingAddressesDetails(zipCode, false, loctype, resp => {
			let warehouseCode = resp && resp.agentid ? resp.agentid : '';
			let warehouseName = resp && resp.dockname ? resp.dockname : '';
			let billingReferenceLabel = '';
			let billingReference = [];
			if (updateBookedOrderDetails.billingReference) {
				updateBookedOrderDetails.billingReference.forEach((item) => {
					billingReferenceLabel = item.billingRefFieldLabel;
					billingReference.push({
						...item,
						name: item.internalName
					});
				});
			}
			const payload = {
				...updateBookedOrderDetails,
				items: itemList,
				orderStatus: 'Create',
				createdById: userDetails.sso,
				createdBy: `${userDetails.firstName} ${userDetails.lastName}`,
				orderTotal: parseFloat(orderTotal).toFixed(2),
				orderSubTotal: parseFloat(orderTotal).toFixed(2),
				warehouseCode,
				warehouseName,
				billingReferenceLabel,
				billingReference,
			};
			delete payload.orderNumber;
			delete payload.referenceNumber;
			payload.requestedDeliveryDate = self.props.pickTheDateFromString(payload.requestedDeliveryDate);
			payload.orderDate = self.props.pickTheDateFromString(payload.orderDate);
			const { selectedAccount } = self.props.state.user;
			payload.customerClassCode = selectedAccount && selectedAccount.CUSTOMERCLASSCODE ? selectedAccount.CUSTOMERCLASSCODE :'';
			const {items} = payload;
			items.forEach((itm)=>{
				// To identify related or unrelated  substitution
				// related: itm.attribute12 === null
				// unrelated: itm.attribute12 != null
				let attribute12Data = itm.attribute.find(item => item.name === "Attribute12");
				let attribute12 = attribute12Data ? attribute12Data.value: null;
				if(itm.lineType === 'Split Delivery' && attribute12 != null) {
					 itm.unrelatedOriginalItem = itm.item;
					 itm.item = attribute12;	
				}
			})
			const substituteItem = items.filter((itm) => itm.unrelatedOriginalItem && itm.unrelatedOriginalItem != null);
			if(substituteItem.length>0){
				payload.substituteFound = true;
			}
			self.props.createNewOrder(payload, "requestType=createOrder", false, response => {
				if(response.status) {
					if (isBackOrderHold) {
						self.setState({
							holdBackOrderCallCompleted: true,
							updateBookedOrderDetails: {
								...self.state.updateBookedOrderDetails,
								createOrderResponse: response.responseObject,
								holdServiceFailed: response.responseObject ? false : true,
								whichCreateOrderCall: 'Hold Backorder'
							}
						}, () => {
							self.props.saveUpdateBookedOrderConfirmationPageData(self.state.updateBookedOrderDetails);
							callback && callback();
						});
					} else {
						self.setState({
							splitDeliveryCallCompleted: true,
							updateBookedOrderDetails: {
								...self.state.updateBookedOrderDetails,
								createOrderResponse: response.responseObject,
								splitDeliveryServiceFailed: response.responseObject ? false : true,
								whichCreateOrderCall: 'Split Delivery'
							}
						}, () => {
							self.props.saveUpdateBookedOrderConfirmationPageData(self.state.updateBookedOrderDetails);
							callback && callback();
						});
					}
				} else {
					browserHistory.push("/error");
				}
			});
		}, true, state);
	}

	makeServiceCallAddtoCart(cartItems, callback) {
		const self = this,
			{ selectedAccount, userDetails } = self.props.state.user;
		self.props.addToCart({
			accountNumber: selectedAccount.ACCOUNTNUMBER,
			createdDate: moment().format('MM/DD/YYYY'),
			updatedDate: moment().format('MM/DD/YYYY'),
			userId: userDetails.sso,
			cartItems
		}, response => {
			if(response.status && response.responseObject) {
				self.props.saveToCart(response);
				self.setState({
					splittedCallCompleted: true
				}, () => {
					callback && callback();
				});
			} else {
				browserHistory.push('/error');
			}
		});
	}

	callbackAFterParallelCall() {
		const self = this;
		const { updateBookedOrderCallCompleted, splittedCallCompleted, holdBackOrderCallCompleted, updateBookedOrderDetails, splitDeliveryCallCompleted } = self.state;
		if (updateBookedOrderCallCompleted && splittedCallCompleted && holdBackOrderCallCompleted && splitDeliveryCallCompleted) {
			const { updateBookedOrderServiceFailed, holdServiceFailed, splitDeliveryServiceFailed } = updateBookedOrderDetails;
			if (!updateBookedOrderServiceFailed && !holdServiceFailed && !splitDeliveryServiceFailed) {
				browserHistory.push('/update/bookedorder/confirmation');
			} else {
				browserHistory.push('/update/bookedorder/confirmationError');
			}
		}
	}

	componentWillMount() {
		const self = this;
		const updateBookedOrderDetails = self.props.state.order.orderDetails;
		let disallowSAErrorMessage = '';
		let { selectedPriceSource, selectedAccountsAllPriceSources, allSelectedAccountsAllPriceSources } = self.props.state.user;
		if(updateBookedOrderDetails && updateBookedOrderDetails.responseObject && updateBookedOrderDetails.responseObject.agreementNumber) {
			selectedPriceSource = selectedAccountsAllPriceSources.responseObject.find(item => item.AGREEMENT_NUMBER === parseInt(updateBookedOrderDetails.responseObject.agreementNumber, 10));
			// If salesagreement is invalid then need to pick selected salesAgreementNumber
			// WCP-7630: then check if that is Disallow New Releases === 'Y'
			if (!selectedPriceSource && allSelectedAccountsAllPriceSources.find(item => item.AGREEMENT_NUMBER === parseInt(updateBookedOrderDetails.responseObject.agreementNumber, 10) && item['Disallow_New_Releases'] === 'Y')) {
				disallowSAErrorMessage = 'The Sales Agreement is no longer active.  Please contact customer service.';
			}
		}
		self.setState({
			selectedPriceSource,
			disallowSAErrorMessage
		});
		// reset back orders from so store to avoid any duplicate checked items
		self.props.saveBackOrders(null);
		self.props.saveBulkOrdersHold(null);
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		const self = this;
		const updateBookedOrderDetails = self.props.state.order.orderDetails;
		if(updateBookedOrderDetails && updateBookedOrderDetails.responseObject) {
			self.setState({
				poNumberValue:updateBookedOrderDetails.responseObject.poNumber,
				deliveryPhoneValue: updateBookedOrderDetails.responseObject.deliveryPhone,
				deliveryInstructionsValue: updateBookedOrderDetails.responseObject.deliveryInstructions
			});
			let anyHoldBackOrderItem = false;
			let anyReservationTransferHold = false;
			let itemsNames ='';
			updateBookedOrderDetails.responseObject.items.forEach(item => {
				itemsNames = `${itemsNames} ${item.item}`;
				if(item.holdType === 'Backorder Hold')
				{
					anyHoldBackOrderItem = true;
				}
			});
			self.props.getSearchKeywordSuggestionList(`requestType=getItems&keyword=${itemsNames.trim()}&accountNumber=${self.props.getSelectedAccountNumber()}&zipCode=${self.props.getZipCode()}&page=search`, resp => {
				self.setState({
					searchKeywordItem : resp.responseObject		
				})
				});
			if(updateBookedOrderDetails.responseObject.holdType.indexOf('Bulk Order - Do not Ship') !== -1) {
				anyHoldBackOrderItem = true;
			}
			if(updateBookedOrderDetails.responseObject.holdType.indexOf('Reservation Transfer Hold') !== -1) {
				anyReservationTransferHold = true;
			}
			self.setState({
				updateBookedOrderDetails: JSON.parse(JSON.stringify(updateBookedOrderDetails.responseObject)),
				updateBookedOrderDetailsBkp: JSON.parse(JSON.stringify(updateBookedOrderDetails.responseObject)),
				anyHoldBackOrderItem,
				anyReservationTransferHold,
			}, () => {
				self.updateOrderPoints();
				const { updateBookedOrderDetails } = self.state;
				if(updateBookedOrderDetails.items.find(item => item.reserved === undefined)) {
					// Need to make call to get reserved data and update object
					self.props.getOrderShippingDetails(updateBookedOrderDetails.orderNumber, response => {
						if(!response.status || !response.responseObject) {
							self.setState({
								errorMessage: response.responseMessage
							});
						} else {
							let orderLineShippingDetails = response.responseObject.orderdetoutrec;
							orderLineShippingDetails = orderLineShippingDetails && orderLineShippingDetails[0] && orderLineShippingDetails[0].linedetailsrec;
							orderLineShippingDetails = orderLineShippingDetails && orderLineShippingDetails.value && orderLineShippingDetails.value.linedetails;
							const { updateBookedOrderDetails } = self.state;
							updateBookedOrderDetails.items.forEach(itm => {
								let data = orderLineShippingDetails.find(it => it.lineid.value.toString() === itm.lineId);
								const dataReservedQty = JSON.parse(JSON.stringify(data));
								data = data.isodetailsrec && data.isodetailsrec.value && data.isodetailsrec.value.isodetails && data.isodetailsrec.value.isodetails[0];
								if(data && data.isoreservationquantity) {
									itm.reserved = data.isoreservationquantity.value
								} else {
									if(dataReservedQty && dataReservedQty.reservedquantity) {
										itm.reserved = dataReservedQty.reservedquantity.value
									}
								}
							});
							self.setState({
								updateBookedOrderDetails,
								updateBookedOrderDetailsBkp: JSON.parse(JSON.stringify(updateBookedOrderDetails)),
							});
						}
					});
				}
			});
		} else {
			browserHistory.push('/manageorders');
		}
	}

	handleCancelEntireOrder(event) {
		event.preventDefault();
		const self = this;
		self.setState({
			genericDialogHeading: "Cancel Entire Order",
			genericDialogText: "Are you sure you want to CANCEL the entire order?",
			modalButtons: 'yes,no'
		}, () => {
			self.handleDialog("CancelEntireOrderConfirmationOverlaydialog", true);
		});
	}

	handleDelete(event) {
		event.preventDefault();
		const self = this;
		self.setState({
			errorMessage: ''
		}, () => {
			self.handleDialog("CancelEntireOrderConfirmationOverlaydialog", false);
		});
		let payload = JSON.parse(JSON.stringify(self.state.updateBookedOrderDetails));
		payload.items.forEach(item => {
			item.action = 'cancel';
		});
		const { userDetails } = self.props.state.user;
		payload = {
			...payload,
			createdById: userDetails.sso,
			createdBy: userDetails.firstName + " " + userDetails.lastName,
			email: userDetails.email,
		};
		self.props.saveUpdateBookedOrderConfirmationPageData(payload);
		// Fire gtm tag for cancel order click only
		self.props.fireGTMTag('Update Booked Order Cancel Order', {
			orderNumber: payload.orderNumber,
		});
		self.props.deleteOrderDetails(payload, 'requestType=cancelOrder', true, response => {
			if(!response.status || !response.responseObject) {
				self.setState({
					errorMessage: response.responseMessage
				});
			} else {
				//Save deleted payload into store for showing on confirmation page
				browserHistory.push('/cancel/bookedorder/confirmation');
			}
		});
	}

	getLocTypeAccordingToDeliveryMethod() {
		const record = _.find(this.props.state.order.pickAgentId, {deliveryMethod: this.getDeliveryMethod()});
		return record && record.loctype ? record.loctype : null;
	}

	getDeliveryMethod() {
		const self = this;
		const { deliveryMethod } = self.state.updateBookedOrderDetails;
		return deliveryMethod;
	}

	handleAddServices(index, item, itemLevelDisableUncrateDropdown, event) {
		event.preventDefault();
		const self = this,
			{ updateBookedOrderDetails } = self.state,
			{ shippingAddress } = updateBookedOrderDetails,
			zipCode = shippingAddress.zip.split('-')[0];
		self.setState({
			itemLevelDisableUncrateDropdown,
			selectedSKU: item,
			selectedSKUIndex: index,
		}, () => {
			// make service call to get warehouseCode and then make pricing service call
			self.props.getShippingAddressesDetails(zipCode, false, self.getLocTypeAccordingToDeliveryMethod(), resp => {
				if(resp && resp.agentid) {
					const record = _.find(self.props.state.order.orderableServices, {sku: item, zipCode: zipCode});
					if(record) {
						self.manageAvailableServices(self.props.state.order.orderableServices, item, zipCode);
					} else {
						const { deliveryMethod } = updateBookedOrderDetails;
						const itemnumbers = self.state.updateBookedOrderDetails.items.filter(item => item.itemType === 'M' && item.item === self.state.selectedSKU).map(item => item.item);
						// Get all orderable services list
						self.props.getOrderableServices({
							OrderabilityRequest: {
								inventoryorg: resp.agentid,
								zipcode: zipCode,
								shipmethod: deliveryMethod,
								itemnumbers
							}
						}, "requestType=getOrderableServices", response => {
							if(response.status) {
								var orderableServices = JSON.parse(JSON.stringify(response));
								const { selectedAccount } = self.props.state.user;
								const { selectedPriceSource } = self.state;
								const servicesPayload = [];
								const { salesAgreementNumber, accountNumber } = self.props.checkForTokenAccountByMasterSA(selectedPriceSource, selectedAccount.ACCOUNTNUMBER);
								response.responseObject && response.responseObject.OrderabilityResponse.orderability.forEach(item => {
									if(item.service.length === 4 && item.service.indexOf("M") === 0) {
										servicesPayload.push({
											pricingEffectiveDate: moment().format('YYYYMMDD'),
											accountNumber,
											state: shippingAddress.state,
											whse: resp.agentid,
											zone: resp.sdsApZone,
											salesAgreementNumber,
											itemNumber: item.service
										});
									}
								});
								self.setState({
									requiredPayloadForServicePricing: {
										pricingEffectiveDate: moment().format('YYYYMMDD'),
										accountNumber,
										state: shippingAddress.state,
										whse: resp.agentid,
										zone: resp.sdsApZone,
										salesAgreementNumber,
										postalCode: shippingAddress.zip.split("-")[0],
										country: shippingAddress.country ? shippingAddress.country : "US"
									}
								}, () => {
									if(servicesPayload.length > 0) {
										// Get all orderable services prices list
										self.props.checkServicePrices({items: servicesPayload}, "requestType=servicesPricing", resp => {
											if(resp.status) {
												// TO DO : Temporary conversion from json string to json
												resp.responseObject = JSON.parse(resp.responseObject);
												// let orderableServices = self.props.state.order.orderableServices;
												const orderableServicesTemp = [];
												orderableServices.responseObject.OrderabilityResponse.orderability.forEach(item => {
													let record = _.find(resp.responseObject.items, {itemNumber: item.service});
													// record.unitPrice = 200;
													if(record && (record.unitPrice || record.unitPrice === 0)) {
														orderableServicesTemp.push({
															...item,
															servicePrice: record.unitPrice,
															serviceDescription: item.description,
														});
													}
												});
												let finalData = [];
												self.state.updateBookedOrderDetails.items.forEach(itm => {
													if (itm.item === self.state.selectedSKU) {
														finalData.push({
															sku: itm.item,
															services: _.filter(orderableServicesTemp, {itemnumber: itm.item}),
															zipCode: zipCode
														});
													}
												});
												let existingOrderableServices = self.props.state.order.orderableServices;
												existingOrderableServices = existingOrderableServices.filter(it => it.sku !== self.state.selectedSKU);
												existingOrderableServices = existingOrderableServices.concat(finalData);
												self.props.saveOrderableServices(existingOrderableServices);
												self.manageAvailableServices(finalData, self.state.selectedSKU, zipCode);
											} else {
												browserHistory.push("/error");
											}
										})
									} else {
										let finalData = [];
										self.state.updateBookedOrderDetails.items.forEach(itm => {
											finalData.push({
												sku: itm.item,
												services: [],
												zipCode: zipCode
											})
										})
										self.manageAvailableServices(finalData, self.state.selectedSKU, zipCode);
									}
								});
							} else {
								browserHistory.push("/error");
							}
						});
					}
				}
			},true,shippingAddress.state);
		});
	}

	manageAvailableServices(finalData, sku, zipCode) {
		const self = this;
		const availableServices = _.find(finalData, {sku, zipCode});
		self.setState({
			availableServices: availableServices && availableServices.services
		}, () => {
			self.handleDialog("AddServicesOverlayDialog", true, null);
		})
	}

	handlePriceSourceDialog(selectedPriceSourceForUpdate, dialog, flag, selectedItem, event) {
		event && event.preventDefault();
		this.setState({
			selectedPriceSourceForUpdate,
			selectedItem: {
				...selectedItem,
				redirectFrom: 'updatebookedorder',
				pricingDate: selectedItem.pricingDate ? this.props.pickTheDateFromString(selectedItem.pricingDate) : selectedItem.pricingDate,
				orderDate: selectedItem.orderDate ? this.props.pickTheDateFromString(selectedItem.orderDate) : selectedItem.orderDate
			}
		}, () => {
			this.handleDialog(dialog, flag, event);
		});
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	redirectToPreviousPage(event) {
		event.preventDefault();
		browserHistory.push("/manageorders");
	}

	handleMoreLines(event) {// add more products and qty
        event.preventDefault();
		const self = this;
        const products = self.state.products,
			{ updateBookedOrderDetails } = self.state;
			products.push({item: "", quantity: 1, availability: null, error: null, itemType: "M", agreementNumber: updateBookedOrderDetails.agreementNumber, poNumber: updateBookedOrderDetails.poNumber});
        self.setState({
            products: products
        });
    }

	updateQuickOrderState(itemIndex, productDetails, makeAvailabilityCall) {
		const self = this,
			products = self.state.products;
        products.map((item, index) => {
            if(index === itemIndex) {
                item.productDetails = productDetails;
                item.item = productDetails.sku;
				delete item.modelNotAvailableError;
				delete item.error;
            }
            return null;
        })
        self.setState({
            products: products,
            isDataValid: true,
        }, () => {
			if(makeAvailabilityCall) {
				self.setState({
					isPimCallCompleted: false,
					orderAvailabilityCompleted: false,
				}, () => {
					const { shippingAddress } = self.state.updateBookedOrderDetails;
					const data = shippingAddress;
					const zipCode = data ? data.zip.split('-')[0] : '';
					zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
						if(resp && resp.agentid) {
							const { selectedPriceSource } = self.props.state.user;
							// new availability call
							const payload = {
								accountNumber: self.props.getSelectedAccountNumber(),
								warehouseCode: resp.agentid,
								customerSiteId: shippingAddress.addressId,
								requestedDeliveryDate: moment().format('MM/DD/YYYY'),// As of now passing the current date as part of WCP-8097
								orderSource: '',
								zipCode: zipCode,
								state: data.state,
								country: data.country,
								tradingPartnerId:'',
								dateType:'SHIP',
								items: [{
									itemNumber: productDetails.sku,
									identifier: 1,
									qty: 1,
									shipSet: 1,
									shipMethod: 'ADC Truckload',
									arrivalSetName: '',
									itemType: '',
									demandClass: self.props.getSalesAgreementParamForAvailability(self.state.products[0].agreementNumber ? self.state.products[0].agreementNumber.toString() : '').split("=")[1],
									overrideFlag: 'N',
									quantityUOM: 'EA',
									agreementNumber: self.state.products[0].agreementNumber,
								}]
							};
							self.props.checkAvailabilityForOrder(payload, response => {
								self.setState({
									orderAvailabilityCompleted: true,
									availabilityData: response,
									availabilityError: response.length === 0 ? true : false,
								}, () => {
									self.callBackAfterAddingNewProduct();
								});
							});
						} else {
							self.setState({
								orderAvailabilityCompleted: true,
								availabilityData: null
							}, () => {
								self.callBackAfterAddingNewProduct();
							});
						}
					}, true, shippingAddress);
	
					const { selectedPriceSource } = self.state,
						skuListForPim = [productDetails.sku];
	
					// make service call to get pim details
					self.props.getPIMItemInfo(skuListForPim, "requestType=getPIMItemInfo", response => {
						if(response.status) {
							const responseObject = response.responseObject ? response.responseObject : null;
							// update products in state with uncrateInd to use it later for priceOrder service
							let finalProducts = [];
							self.state.products.forEach(item => {
								if(!item || !item.item) return null;
								let uncrateInd = item.uncrateInd || "N";
								const pimItemData = _.find(responseObject, { item_number: item.item });
								if(pimItemData && pimItemData.geego_uncrateind) {
									let geego_uncrateind = pimItemData.geego_uncrateind;
									const { selectedAccountsAllPriceSources } = self.props.state.user;
									const record  = selectedAccountsAllPriceSources && _.find(selectedAccountsAllPriceSources.responseObject, {AGREEMENT_NUMBER: selectedPriceSource.AGREEMENT_NUMBER});
									if(record) {
										uncrateInd = record[geego_uncrateind] === "Y"?"Y":"N";
									}
								}
								const lifeCyclePhase = pimItemData && pimItemData.length> 0 ? pimItemData[0].lifecycle_phase : pimItemData.lifecycle_phase;
								finalProducts.push({
									...item,
									uncrateInd,
									lifeCyclePhase,
									pimLifeCycleError : lifeCyclePhase === "Near End of Life" ? true : false,
								});
							});
							self.setState({
								isPimCallCompleted: true,
								pimData: responseObject,
								products: finalProducts
							}, () => {
								self.callBackAfterAddingNewProduct();
							});
						}
					});
				});
			}
		});
    }

	getIndexes(array, pickFromArray, value) {
		const indexes = [];
		array.forEach((itm, ind) => {
			if(itm === value)
				indexes.push(pickFromArray[ind]);
		});
		return indexes;
	}

	callBackAfterAddingNewProduct() {
		const self = this;
		const { isPimCallCompleted, orderAvailabilityCompleted, pimData } = this.state;
		if(isPimCallCompleted && orderAvailabilityCompleted) {
			const items = self.state.updateBookedOrderDetails.items;
			const requestedDeliveryDate = self.props.pickTheDateFromString(self.state.updateBookedOrderDetails.requestedDeliveryDate);
			const finalObject = [];
			let attributeName = "geego_top_load";
			self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
				if(!resp) {
					attributeName = "geego_no_top_load";
				}
				self.state.products.forEach(item => {
					const availability = _.find(item.productDetails.availabilityData, {sku: item.item});
					const pimItemData = _.find(pimData, {item_number: item.item});
					let expectedAvailableDate = '';
					const availabilityData = self.state.availabilityData && self.state.availabilityData.find(itm => itm.itemNumber === item.item);
					if(availabilityData && availabilityData.shipDate) {
						expectedAvailableDate = self.props.pickTheDateFromString(availabilityData.shipDate);
					}
					if(availability && pimItemData) {
						const hasReplacement = pimItemData && pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Superseded") !== -1?true:false;
						const replacementSKUs = hasReplacement?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Superseded"):[];
						const hasSubstitute = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Substitute") !== -1?true:false;
						const substituteSKUs = hasSubstitute?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Substitute"):[];
						const hasUpgrade = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Up-Sell") !== -1?true:false;
						const upgradeSKUs = hasUpgrade?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Up-Sell"):[];
						const isFedexable = pimItemData.geego_fedexable === "Y" ? true : false;
						const lifeCyclePhase = pimItemData && pimItemData.length> 0 ? pimItemData[0].lifecycle_phase : pimItemData.lifecycle_phase;
						const agreementNumber = self.state.selectedPriceSource.AGREEMENT_NUMBER;
						let price = 0;
						price = _.find(item.productDetails.pricingData, { item_number: item.item });
						if(price && price.records && price.records.length > 0) {
							price = price.records[0].adjusted_unit_price || price.records[0].unit_price
							if(price) {
								item.price = price;
							}
						}
						// WCP-7541: Currently, we only allow the user to models that are available now.
						// I would like to change that logic, to allow the user to add models that are available now OR models with an ETA (from the ATP service) BEFORE the RDD.
						if((availability.availableQty && availability.availableQty !== '0') || moment(availability.etaDate).isBefore(requestedDeliveryDate)) {
							items.push({
								item: item.item,
								itemDescription: item.productDetails && item.productDetails.description,
								itemType: availability.itemType,
								quantity: item.quantity,
								quantityError: '',
								availability: availability.availableQty,
								eta: availability.etaDate,
								availabilityBkp: availability.availableQty,
								etaBkp: availability.etaDate,
								price: item.price,
								expectedAvailableDate,
								overpackQuantityRequired:(item.productDetails && item.productDetails.overpackQuantityRequired),
								packageQuantity: item.productDetails.packageQuantity,
								pricingDate: moment().format(DATE_TIME_FORMAT),
								relatedServices: [],
								pointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * item.quantity) : 0.00,
								perItemPointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00,
								geego_cust_acct: pimItemData.geego_cust_acct,
								weight: self.props.getOrderWeightFromPimData(pimItemData, item.quantity),
								perItemWeight: self.props.getOrderWeightFromPimData(pimItemData, 1),
								lifeCyclePhase,
								agreementNumber,
								hasReplacement,
								hasSubstitute,
								hasUpgrade,
								replacementSKUs,
								substituteSKUs,
								upgradeSKUs,
								isFedexable,
								poNumber: item.poNumber,
								uncrateInd: item.uncrateInd,
								requestedDeliveryDate: 'delivery1',
								whenAdded: 'new',
							});
							item = null;
						} else {
							if (moment(availability.etaDate).isAfter(requestedDeliveryDate)) {
								item.modelNotAvailableError = true;
							}
							item.error = 'error';
						}
					}
					item && finalObject.push(item);
				});
				self.setState({
					products: finalObject,
					updateBookedOrderDetails: {
						...self.state.updateBookedOrderDetails,
						items
					}
				}, () => {
					self.updateOrderPoints();
				});
			});
		}
	}

	handleChangeProductNumberTextBox(itemIndex, productNumber) {
        var products = this.state.products;
        products.map((item, index) => {
            if(index === itemIndex) {
                item.item = productNumber;
                if(productNumber === '') {
                    item.productDetails = null
                };
				delete item.modelNotAvailableError;
            }
            return null;
        })
        this.setState({
            products: products
        });
    }

	getZipCode() {
		const self = this;
		const { updateBookedOrderDetails } = self.state;
		if(updateBookedOrderDetails && updateBookedOrderDetails.shippingAddress && updateBookedOrderDetails.shippingAddress.zip) {
			return updateBookedOrderDetails.shippingAddress.zip.split("-")[0]
		}
		return self.props.getZipCode();
	}

	handleSelectActionAddedProducts(index, event) {
		const self = this,
			action = event.target.value;
		let items = JSON.parse(JSON.stringify(self.state.products));
		if(action === "D") {
			const finalObject = [];
			items.forEach((item, indx) => {
				if(indx === index)
					finalObject.push(null);
				else
					finalObject.push(item);
			})
			// update items after operation is completed
			self.setState({
				products: finalObject
			});
		}
		event.target.value = "";
	}

	callBackAfterGettingAllProductsData(callback) {
		const self = this;
		const { isAvailabilityCallCompleted, isPricingCallCompleted, isPimCallCompleted } = self.state;
		if(isAvailabilityCallCompleted && isPricingCallCompleted && isPimCallCompleted) {
			callback && callback();
		}
	}

	getAllProductsData(skuList, quantity, currentSKU, agreementNumber, callback) {
		const self = this;
		const operatedSKU = skuList;
		const { selectedAccount } = self.props.state.user,
			skuListForPim = skuList.map(item => item.sku);
		// Make availability call
		const accountNumber = selectedAccount.ACCOUNTNUMBER;
		self.setState({
			isAvailabilityCallCompleted: false,
			isPricingCallCompleted: false,
			isPimCallCompleted: false,
		}, () => {
			const data = JSON.parse(self.props.state.user.selectedAddress);
			const zipCode = data ? data.POSTALCODE.split('-')[0] : '';
			zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
				if(resp && resp.agentid) {
					self.props.checkAvailabilityAndOrderability(skuList, `accountNumber=${accountNumber}&zipCode=${self.getZipCode()}&legacyCustCode=${self.props.getLegacyCustCode()}&warehouseCode=${resp.agentid}${this.props.getSalesAgreementParamForAvailability()}`, self.getSelectedAddressParams(), '', false, response => {
						self.setState({
							isAvailabilityCallCompleted: true,
							availabilityData: response.responseObject
						}, () => {
							self.callBackAfterGettingAllProductsData(callback);
						});
					});
				}
			});

			// make service call to get warehouseCode and then make pricing service call
			// now for quick order page first make product pricing service call to calculate total cost
			const pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
			self.props.checkPricesForSearchResult({
				account_number: accountNumber,
				pricing_effective_date: pricingEffectiveDate,
				sa_number: agreementNumber,
				item_numbers: skuListForPim
			}, true, false, response => {
				if(response.status) {
					response = self.props.processPricingResponse(response);
					operatedSKU.forEach((item, index) => {
						if(!item.sku) return null;
						let price = 0;
						price = _.find(response.responseObject.items, { item_number: item.sku });
						if(price && price.records && price.records.length > 0)
							price = price.records[0].adjusted_unit_price || price.records[0].unit_price
						else {
							price = 0;
						}
						// totalCartCost += price * quantity;
						item.originalPrice = price;
						return null
					});
					self.setState({
						isPricingCallCompleted: true,
						pricingData: operatedSKU
					}, () => {
						self.callBackAfterGettingAllProductsData(callback);
					});
				} else {
					browserHistory.push("/error");
				}
			});

			// make service call to get pim details
			self.props.getPIMItemInfo(skuListForPim, "requestType=getPIMItemInfo", response => {
				if(response.status) {
					const responseObject = response.responseObject ? response.responseObject : null;
					self.setState({
						isPimCallCompleted: true,
						pimData: responseObject
					}, () => {
						self.callBackAfterGettingAllProductsData(callback);
					});
				}
			})
		});
	}

	handleSelectAction(index, item, event) {
		const self = this,
			action = event.target.value;
		let items = [];

		// First delete action of current product first in order to keep it latest
		// It will get updated accordingly below
		// const { deletedItems } = self.props.state.order;
		self.state.updateBookedOrderDetails.items.forEach((itm, indx) => {
			if(index === indx && item.whenAdded !== 'new') {
				if(action === "D") {
					// deletedItems.push(JSON.parse(JSON.stringify({
					// 	...itm,
					// 	action: 'delete'
					// })));
				} else {
					const tmpItm = JSON.parse(JSON.stringify(itm));
					delete tmpItm.action;
					items.push(tmpItm);
				}
			} else {
				items.push(JSON.parse(JSON.stringify(itm)));
			}
		});
		// self.props.saveDeletedItems(deletedItems);
		if(action === "D" && item.whenAdded === 'new') {
			items = _.filter(items, (item, indx) => indx !== index );
		} else if(action === "P") {
			self.setState({
				selectedSKU: item.item,
				selectedSKUIndex: index,
				selectedPriceSourceForUpdate: item.agreementNumber,
			}, () => {
				self.handleDialog('SelectPriceSourceOverlayDialog', true, null);
			});
		} else if(action === "R"){
			self.setState({
				showReplaceProductOverlayDialog: false,
				selectedSKU: item.item,
				selectedSKUIndex: index,
				replacementSKUData: null
			}, () => {
				const skuList = item.replacementSKUs.map(itm => ({sku: itm, itemType: 'M'}));
				if(skuList.length > 0) {
					self.getAllProductsData(skuList, item.quantity, item.item, item.agreementNumber, () => {
						const { availabilityData, pricingData, pimData } = self.state;
						if(availabilityData.length > 0) {
							const availability = availabilityData[0];
							let salesPriceData = _.find(pricingData, itm => {
								return itm.sku === availability.sku && itm.originalPrice
							});
							const pimItemData = _.find(pimData, {item_number: availability.sku});
							if(availability && salesPriceData && pimItemData) {
								const hasReplacement = pimItemData && pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Superseded") !== -1?true:false;
								const replacementSKUs = hasReplacement?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Superseded"):[];
								const hasSubstitute = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Substitute") !== -1?true:false;
								const substituteSKUs = hasSubstitute?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Substitute"):[];
								const hasUpgrade = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Up-Sell") !== -1?true:false;
								const upgradeSKUs = hasUpgrade?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Up-Sell"):[];
								const isFedexable = pimItemData.geego_fedexable === "Y" ? true : false;
								let uncrateInd = "N";
								if(pimItemData.geego_uncrateind) {
									let geego_uncrateind = pimItemData.geego_uncrateind;
									const { selectedAccountsAllPriceSources } = self.props.state.user;
									const { selectedPriceSource } = self.state;
									const record  = selectedAccountsAllPriceSources && _.find(selectedAccountsAllPriceSources.responseObject, {AGREEMENT_NUMBER: selectedPriceSource.AGREEMENT_NUMBER});
									if(record) {
										uncrateInd = record[geego_uncrateind] === "Y"?"Y":"N";
									}
								}
								let attributeName = "geego_top_load";
								self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
									if(!resp) {
										attributeName = "geego_no_top_load";
									}
									let replacingBy = {
										item: availability.sku,
										itemDescription: pimItemData.item_description,
										availability: availability.availableQty,
										itemType: "M",
										eta: availability.etaDate,
										price: salesPriceData.originalPrice,
										originalPrice: salesPriceData.originalPrice,
										relatedServices: self.props.prepareBagItems(salesPriceData),
										pointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * 1) : 0.00,
										weight: self.props.getOrderWeightFromPimData(pimItemData, 1),
										hasReplacement,
										hasSubstitute,
										hasUpgrade,
										replacementSKUs,
										substituteSKUs,
										upgradeSKUs,
										isFedexable,
										uncrateInd
									};
									self.setState({
										showReplaceProductOverlayDialog: true,
										replacementSKUData: {
											replacingTo: item,
											replacingBy
										}
									});
								});
							} else {
								self.setState({
									showReplaceProductOverlayDialog: true,
									replacementSKUData: {
										replacingTo: item,
										replacingBy: null
									}
								});
							}
						} else {
							self.setState({
								showReplaceProductOverlayDialog: true,
								replacementSKUData: {
									replacingTo: item,
									replacingBy: null
								}
							});
						}
					})
				} else {
					self.setState({
						showReplaceProductOverlayDialog: true,
						replacementSKUData: {
							replacingTo: item,
							replacingBy: null
						}
					});
				}
			})
		} else if(action === "S"){
			self.setState({
				showSubstituteProductOverlayDialog: false,
				selectedSKU: item.item,
				selectedSKUIndex: index,
				substituteSKUData: null,
				selectedRDD: moment(self.state.updateBookedOrderDetails.requestedDeliveryDate),
			}, () => {
				const skuList = item.substituteSKUs.map(item => ({sku: item, itemType: 'M'}));
				if(skuList.length > 0) {
					self.getAllProductsData(skuList, item.quantity, item.item, item.agreementNumber, data => {
						const { availabilityData, pricingData, pimData } = self.state;
						if(availabilityData.length > 0) {
							const substituteSKUData = [];
							let attributeName = "geego_top_load";
							self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
								if(!resp) {
									attributeName = "geego_no_top_load";
								}
								availabilityData.forEach(item => {
									const availability = item;
									let salesPriceData = _.find(pricingData, itm => {
										return itm.sku === availability.sku
									});
									const pimItemData = _.find(pimData, {item_number: availability.sku});
									if(availability && salesPriceData && pimItemData) {
										const hasReplacement = pimItemData && pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Superseded") !== -1?true:false;
										const replacementSKUs = hasReplacement?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Superseded"):[];
										const hasSubstitute = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Substitute") !== -1?true:false;
										const substituteSKUs = hasSubstitute?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Substitute"):[];
										const hasUpgrade = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Up-Sell") !== -1?true:false;
										const upgradeSKUs = hasUpgrade?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Up-Sell"):[];
										const isFedexable = pimItemData.geego_fedexable === "Y" ? true : false;
										let uncrateInd = "N";
										if(pimItemData.geego_uncrateind) {
											let geego_uncrateind = pimItemData.geego_uncrateind;
											const { selectedAccountsAllPriceSources } = self.props.state.user;
											const { selectedPriceSource } = self.state;
											const record  = selectedAccountsAllPriceSources && _.find(selectedAccountsAllPriceSources.responseObject, {AGREEMENT_NUMBER: selectedPriceSource.AGREEMENT_NUMBER});
											if(record) {
												uncrateInd = record[geego_uncrateind] === "Y"?"Y":"N";
											}
										}
										substituteSKUData.push({
											item: availability.sku,
											itemDescription: pimItemData.item_description,
											availability: availability.availableQty,
											itemType: "M",
											eta: availability.etaDate,
											price: salesPriceData.originalPrice,
											originalPrice: salesPriceData.originalPrice,
											relatedServices: self.props.prepareBagItems(salesPriceData),
											pointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * 1) : 0.00,
											weight: self.props.getOrderWeightFromPimData(pimItemData, 1),
											hasReplacement,
											hasSubstitute,
											hasUpgrade,
											replacementSKUs,
											substituteSKUs,
											upgradeSKUs,
											isFedexable,
											uncrateInd
										});
									}
								});
								if(substituteSKUData.length > 0) {
									self.setState({
										showSubstituteProductOverlayDialog: true,
										substituteSKUData
									});
								} else {
									self.setState({
										showSubstituteProductOverlayDialog: true,
										substituteSKUData: []
									});
								}
							});
						} else {
							self.setState({
								showSubstituteProductOverlayDialog: true,
								substituteSKUData: []
							});
						}
					})
				} else {
					self.setState({
						showSubstituteProductOverlayDialog: true,
						substituteSKUData: []
					});
				}
			})
		} else if(action === "U") {
			self.setState({
				showUpgradeProductOverlayDialog: false,
				selectedSKU: item.item,
				selectedSKUIndex: index,
				upgradeSKUData: null
			}, () => {
				const skuList = item.upgradeSKUs.map(item => ({sku: item, itemType: 'M'}));
				if(skuList.length > 0) {
					self.getAllProductsData(skuList, item.quantity, item.item, item.agreementNumber, data => {
						const { availabilityData, pricingData, pimData } = self.state;
						if(availabilityData.length > 0) {
							const upgradeSKUData = [];
							let attributeName = "geego_top_load";
							self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
								if(!resp) {
									attributeName = "geego_no_top_load";
								}
								availabilityData.forEach(item => {
									const availability = item;
									let salesPriceData = _.find(pricingData, itm => {
										return itm.sku === availability.sku && itm.originalPrice
									});
									const pimItemData = _.find(pimData, {item_number: availability.sku});
									if(availability && salesPriceData && pimItemData) {
										const hasReplacement = pimItemData && pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Superseded") !== -1?true:false;
										const replacementSKUs = hasReplacement?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Superseded"):[];
										const hasSubstitute = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Substitute") !== -1?true:false;
										const substituteSKUs = hasSubstitute?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Substitute"):[];
										const hasUpgrade = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Up-Sell") !== -1?true:false;
										const upgradeSKUs = hasUpgrade?self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Up-Sell"):[];
										const isFedexable = pimItemData.geego_fedexable === "Y" ? true : false;
										let uncrateInd = "N";
										if(pimItemData.geego_uncrateind) {
											let geego_uncrateind = pimItemData.geego_uncrateind;
											const { selectedAccountsAllPriceSources } = self.props.state.user;
											const { selectedPriceSource } = self.state;
											const record  = selectedAccountsAllPriceSources && _.find(selectedAccountsAllPriceSources.responseObject, {AGREEMENT_NUMBER: selectedPriceSource.AGREEMENT_NUMBER});
											if(record) {
												uncrateInd = record[geego_uncrateind] === "Y"?"Y":"N";
											}
										}
										upgradeSKUData.push({
											item: availability.sku,
											itemDescription: pimItemData.item_description,
											availability: availability.availableQty,
											itemType: "M",
											eta: availability.etaDate,
											price: salesPriceData.originalPrice,
											originalPrice: salesPriceData.originalPrice,
											relatedServices: self.props.prepareBagItems(salesPriceData),
											pointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * 1) : 0.00,
											weight: self.props.getOrderWeightFromPimData(pimItemData, 1),
											hasReplacement,
											hasSubstitute,
											hasUpgrade,
											replacementSKUs,
											substituteSKUs,
											upgradeSKUs,
											isFedexable,
											uncrateInd
										});
									}
								});
								if(upgradeSKUData.length > 0) {
									self.setState({
										showUpgradeProductOverlayDialog: true,
										upgradeSKUData
									});
								} else {
									self.setState({
										showUpgradeProductOverlayDialog: true,
										upgradeSKUData: []
									});
								}
							});
						} else {
							self.setState({
								showUpgradeProductOverlayDialog: true,
								upgradeSKUData: []
							});
						}
					})
				} else {
					self.setState({
						showUpgradeProductOverlayDialog: true,
						upgradeSKUData: []
					});
				}
			})
		} else if(action === "F" || action === "H") {
			items.forEach((itm, indx) => {
				if(index === indx) {
					itm.action = action === "F"?"Force":"Hold";
				}
			});
		}
		// update items after operation is completed
		self.setState({
			updateBookedOrderDetails: {
				...self.state.updateBookedOrderDetails,
				items
			}
		}, () => {
			self.updateOrderPoints();
		});
		event.target.value = (action === "F" || action === "H")?event.target.value: "";
	}

	handleSelectedServices(serviceData, skuList, selectedSKUIndex) {
		var self = this,
			items = self.state.updateBookedOrderDetails.items;
			// scrollToItemIndex = 0;
	    items.map((item, index) => {
			if(index === selectedSKUIndex) {
				// scrollToItemIndex = index;
                if(skuList) {
                    item.relatedServices = skuList;
                }
				if(item.relatedServices.length === 0) {
					delete item.relatedServices;
				}
				const bagItems = item.relatedServices ? _.filter(item.relatedServices, {type: 'BAG'}) : [];
				if(bagItems.length !== item.relatedServices.length) {
					item.uncrateInd = item.relatedServices && item.relatedServices.length > 0 ? 'Y' : 'N';
				} else {
					item.uncrateInd = 'N';
				}
			}
			return null;
		})
		self.setState({
			showAddServicesOverlayDialog: false,
			updateBookedOrderDetails: {
				...self.state.updateBookedOrderDetails,
				items
			}
		});
		// window.scrollTo(0, self.getElementOffset("quantity"+scrollToItemIndex));
		self.resetSelectedSKU();
	}

	handleActionChangeService(index, serviceId, event) {
		const self = this;
		if(event.target.value === 'D') {
			let items = self.state.updateBookedOrderDetails.items;
			items.map((item, indx) => {
				if(index === indx) {
					item.relatedServices = _.pullAllBy(item.relatedServices, [{'serviceId': serviceId}], 'serviceId');
					item.uncrateInd = item.relatedServices.length === 0 ? 'N' : 'Y';
				}
				return null;
			})
			self.setState({
				updateBookedOrderDetails: {
					...self.state.updateBookedOrderDetails,
					items
				}
			});
			event.target.value = "";
		}
	}

	handleChangeQuantityService(index, serviceId, event) {
		const self = this;
		let items = self.state.updateBookedOrderDetails.items;
		items.map((item, indx) => {
			if(index === indx) {
				item.relatedServices.map((itm, ind) => {
					if(itm.serviceId === serviceId) {
						itm.quantity = event.target.value
						itm.quantityError = event.target.value === ''?'error':''
					}
					return null;
				})
			}
			return null;
		});
		self.setState({
			updateBookedOrderDetails: {
				...self.state.updateBookedOrderDetails,
				items
			}
		});
	}

	showBackOrdersBlock(event) {
		event.preventDefault();
		this.setState({
			showBackOrders: true
		});
	}

	handleUpgradeItem(selectedUpgradeItem, whichAction = 'upgrade') {
		//Logic to replace item with new item
		var finalItems = [],
			self = this;
		//Ignore adding item in case that item is already added in order list
		if(_.find(self.state.updateBookedOrderDetails.items, ['item', selectedUpgradeItem.sku])) {
			finalItems = self.state.updateBookedOrderDetails.items;
		} else {
			self.state.updateBookedOrderDetails.items.map((item, index) => {
				if(index === self.state.selectedSKUIndex) {
					let tempItm = JSON.parse(JSON.stringify(item));
					if(item.whenAdded !== 'new') {
						delete tempItm.alreadyAdded;
						tempItm = {
							...tempItm,
							action: 'update'
						};
					}
					let scheduleArrivalDate = item.scheduleArrivalDate;
					if (whichAction === 'substitute') {
						tempItm.originalItem = item.item;
						tempItm.originalItemPrice = item.price;
						if (!selectedUpgradeItem.price || selectedUpgradeItem.price === "0") {
							selectedUpgradeItem.price = item.price;
							selectedUpgradeItem.originalPrice = item.originalPrice;
						}
						// check if scheduled arrival date is there and its before today + 2 date
						// then update the schedule arrival date with today + 2 days
						const todaysPlus2 = moment().tz('America/New_York').add(2, 'days');
						if (scheduleArrivalDate && moment(scheduleArrivalDate).isBefore(todaysPlus2)) {
							scheduleArrivalDate = todaysPlus2.format('YYYY-MM-DD') + scheduleArrivalDate.substring(10);
						}
					}
					finalItems.push({
						...tempItm,
						...selectedUpgradeItem,
						scheduleArrivalDate
					});
				} else {
					finalItems.push(item);
				}
				return null;
			});
		}
		self.setState({
			updateBookedOrderDetails: {
				...self.state.updateBookedOrderDetails,
				items: finalItems
			},
			selectedSKU: selectedUpgradeItem.sku,
			showUpgradeProductOverlayDialog: false,
			showSubstituteProductOverlayDialog: false
		});
		self.resetSelectedSKU();
	}

	handleReplace(replaceWith) {
		var self = this;
		if(replaceWith === 'same') {
			self.setState({
				showReplaceProductOverlayDialog: false
			})
		} else {
			//Logic to replace item with new item
			var finalItems = [];
			//Ignore adding item in case that item is already added in order list
			if(_.find(self.state.updateBookedOrderDetails.items, ['item', self.state.replacementSKUData.replacingBy.item])) {
				finalItems = self.state.updateBookedOrderDetails.items;
			} else {
				self.state.updateBookedOrderDetails.items.map((item, index) => {
					if(index === self.state.selectedSKUIndex) {
						var tempItm = JSON.parse(JSON.stringify(item));
						if(item.alreadyAdded) {
							delete tempItm.alreadyAdded;
							tempItm = {
								...tempItm,
								action: 'update'
							};
						}
						finalItems.push({
							...tempItm,
							...self.state.replacementSKUData.replacingBy
						});
					} else {
						finalItems.push(item);
					}
					return null;
				});
			}
			self.setState({
				updateBookedOrderDetails: {
					...self.state.updateBookedOrderDetails,
					items: finalItems
				},
				selectedSKU: self.state.replacementSKUData.replacingBy.sku,
				showReplaceProductOverlayDialog: false
			})
		}
		self.resetSelectedSKU();
	}

	getElementOffset(elementId) {
		var bodyRect = document.body.getBoundingClientRect(),
			el2 = document.getElementById(elementId).getBoundingClientRect(),
			offset   = el2.top - bodyRect.top;
		return offset;
	}

	changeSelectedPriceSource(changedPriceSource) {
		const self = this;
		let anyChange = false;
		let items = self.state.updateBookedOrderDetails.items;
		const skuListForPim = [];
		items.forEach((item, index) => {
			if(index === self.state.selectedSKUIndex && item.agreementNumber.toString() !== changedPriceSource.toString()) {
				anyChange = true;
				item.agreementNumber = changedPriceSource
				skuListForPim.push(item.item);
			}
		});

		if(anyChange) {
			const { selectedPriceSource } = self.state;
			// make service call to get warehouseCode and then make pricing service call
			const agreementNumber = selectedPriceSource.AGREEMENT_NUMBER;
			// now for quick order page first make product pricing service call to calculate total cost
			const pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
			self.props.checkPricesForSearchResult({
				account_number: self.props.getSelectedAccountNumber(),
				pricing_effective_date: pricingEffectiveDate,
				sa_number: agreementNumber,
				item_numbers: skuListForPim
			}, true, false, response => {
				if(response.status) {
					response = self.props.processPricingResponse(response);
					let price = 0;
					price = _.find(response.responseObject.items, { item_number: skuListForPim[0] });
					if(price && price.records && price.records.length > 0)
						price = price.records[0].adjusted_unit_price || price.records[0].unit_price
					else {
						price = 0;
					}
					// if no price then show actionError
					let itemsUpdated = self.state.updateBookedOrderDetails.items;
					itemsUpdated[self.state.selectedSKUIndex].actionError = price ? '' : 'error'
					self.setState({
						updateBookedOrderDetails: {
							...self.state.updateBookedOrderDetails,
							items: itemsUpdated
						}
					}, () => {
						self.resetSelectedSKU();
					});
				} else {
					browserHistory.push("/error");
				}
			});
		} else {
			self.resetSelectedSKU();
		}
	}

	resetSelectedSKU() {
		var self = this;
		setTimeout(() => {
			self.setState({
				selectedSKU: '',
				selectedSKUIndex: '',
			})
		}, 1000);
	}

	checkIfAnyInvalidSalesAgreement(callback) {
		const self = this;
		self.props.getPriceSources(self.props.getSelectedAccountNumber(), false, selectedAccountsAllPriceSources => {
			let flag = false;
			const { items } = self.state.updateBookedOrderDetails;
			const invalidSAItems = [];
			items.forEach(item => {
				if (item.agreementNumber && !selectedAccountsAllPriceSources.find(itm => itm.AGREEMENT_NUMBER.toString() === item.agreementNumber.toString())) {
					flag = true;
					invalidSAItems.push(item);
				}
			});
			self.setState({
				invalidSAItems
			}, () => {
				invalidSAItems.length && self.handleDialog("InvalidSalesAgreementOverlayDialog", true);
			});
			callback(flag);
		});
	}

	validatePONumberCharactersItemLevel(index, event) {
		const self = this;
		const { items } = self.state.updateBookedOrderDetails;
		items[index].invalidPONumberItemLevel = !self.props.isValidPONumberCharacter(event);
		self.setState({
			updateBookedOrderDetails: {
				...self.state.updateBookedOrderDetails,
				items
			}
		});
	}

	getPricingOfNotKeepOriginalPrice(backOrdersSelectedItems, callback) {
		const self = this;
		const notKeepOriginalPrice = backOrdersSelectedItems.filter(item => item.keepOriginalPrice !== 'Y');
		if(notKeepOriginalPrice.length) {
			const items = JSON.parse(JSON.stringify(backOrdersSelectedItems));
			self.props.makeParallelCallsForCartPrices(
				notKeepOriginalPrice,
				true,
				true,
				'order',
				null,
				() => {
					const { prices } = self.props.state.order;
					if(prices) {
						items.forEach((item, index) => {
							if(item.keepOriginalPrice !== 'Y') {
								let price = 0;
								price = _.find(prices, (itm) => {
									return itm.item_number === item.item && itm.records[0] && itm.records[0].sa_number.toString() === item.agreementNumber.toString();
								});
								if(price && price.records && price.records.length > 0) {
									price = price.records[0].adjusted_unit_price || price.records[0].unit_price
								} else {
									price = 0;
								}
								item.price = price;
								item.originalPrice = price;
							}
						});
						callback(items);
					} else {
						browserHistory.push("/error");
					}
				}
			);
		} else {
			callback(backOrdersSelectedItems);
		}
	}

	checkIfStateIsAk() {
		const self = this;
		const { shippingAddress } = self.state.updateBookedOrderDetails;
		let flag = false;
		if((shippingAddress && shippingAddress.state === 'AK') || self.getDeliveryMethod().indexOf('Ocean') !== -1) {
			flag = true;
		}
		return flag;
	}

	isValidPhoneNumber(s) {
		s = s.replace(/\D+/g, "");
		return (/^1?[2-9][0-9]{9}$/).test(s);
	}

	normalizePhoneNumber(s) {
		if(!s) return '';
		var npa, nxx, xxxx, n;

		n = s.replace(/\D+/g, "");
		if ((/^1?([2-9]\d{2})(\d{3})(\d{4})$/).test(n)) {
			npa  = RegExp.$1;
			nxx  = RegExp.$2;
			xxxx = RegExp.$3;
			n = "(%s) %s-%s".replace(/%s/, npa).replace(/%s/, nxx).replace(/%s/, xxxx);
			return n;
		}
		return s;
	}

	onBlurValidatePhoneNumber(event) {
		const self = this;
		const phoneNumber = event.target.value;
			if(self.isValidPhoneNumber(phoneNumber)) {
				self.setState({
				 deliveryPhoneValue: self.normalizePhoneNumber(phoneNumber)
				});
			}
	}

	getShippingAddressZipCode() {
		const self = this;
		const { shippingAddress } = self.state.updateBookedOrderDetails;
		return shippingAddress.zip.split("-")[0];
	}

	getShippingAddressState() {
		const self = this;
		const { shippingAddress } = self.state.updateBookedOrderDetails;
		return shippingAddress.state;
	}

	manipulateClipBoardOfPONumber(index, whichItem, event) {
		this.props.manipulateClipBoardOfPONumber((e) => {
			if(whichItem === 'new') {
				this.onChangeUpdateParamForNewProduct(index, e);
			} else {
				this.onChangeUpdateParam(index, e);
			}
		}, undefined, undefined, event);
	}

	getSelectedAddressParams() {
		const self = this;
		const { shippingAddress } = self.state.updateBookedOrderDetails;
		let queryString = '';
		if (shippingAddress) {
			const {
				state,
				zip,
			} = shippingAddress;
			queryString = `&state=${state}&country=US&zip=${zip ? zip.split('-')[0] : zip}`;
		}
		return queryString;
	}

	isScheduledArrivalDateIsGreaterThan8Days(items = []) {
		const self = this;
		let flag = false;
		const afterEightDaysDate = moment().add(8, 'days').hours(0).minutes(0).seconds(0).milliseconds(0);
		items.forEach(item => {
			if (item.scheduleArrivalDate) {
				const scheduleArrivalDate = moment(self.props.pickTheDateFromString(item.scheduleArrivalDate)).hours(0).minutes(0).seconds(0).milliseconds(0);
				if (scheduleArrivalDate.isAfter(afterEightDaysDate)) {
					flag = true;
				}
			}
		});
		return flag;
	}

	isMService(itemName) {
		let flag = false;
		if (itemName.length === 4 && itemName.indexOf("M") === 0) {
			flag = true;
		}
		return flag;
	}
	changeDeliveryMethod(deliveryMethod) {
		if (['SDS Delivery', 'SDS Will Call'].includes(deliveryMethod)) {
			const { shippingAddress, warehouseCode } = this.state.updateBookedOrderDetails;
			const shipToZipCode = shippingAddress && shippingAddress.zip && shippingAddress.zip.split('-')[0];
			const shipToState = shippingAddress && shippingAddress.state;
	
			const deliveryCalendarPayload = {
				accountNo: this.props.state.user.selectedAccount.ACCOUNTNUMBER,
				zipcode: shipToZipCode,
				state: shipToState,
				mode: deliveryMethod === 'SDS Delivery' ? 'SDS' : deliveryMethod === 'SDS Will Call' ? 'WILLCALL' : null,
				deliveryAgent: warehouseCode,
				noOfDays: 180
			};
			this.props.getDeliveryCalendar(deliveryCalendarPayload, 'requestType=getSdsCalendar', true, deliveryCalendarResponse => {
				this.setState({
			deliveryMethod,
					deliveryCalendar: (deliveryCalendarResponse.responseObject && deliveryCalendarResponse.responseObject.calendar_dates) || [],
					showChangeShippingMethodOverlayDialog: false,
			showChangeRequestedDeliveryDateOverlayDialog: true
				})
			});
		} else {
			this.setState({
				deliveryMethod,
				showChangeShippingMethodOverlayDialog: false,
				showChangeRequestedDeliveryDateOverlayDialog: true
		});
		}
	}
	callBackAfterRDDUpdate(rdd) {
		const self = this;
		const newPayload = JSON.parse(JSON.stringify(self.state.payload));
		newPayload.items = newPayload.items.filter(item => item.lineType === 'Split Delivery');
		newPayload.items.forEach(item => {
			item.reservedQty = item.reserved;
			item.lineNo = `${item.lineNo}.${item.shipmentNumber}`;
			// WCP-7554: removed reserved condition
			// If reserved then only send originalOrderNumber (lineNo) && 
			// parseInt(item.reserved, 10) === parseInt(item.quantity, 10) &&
			// Dont send originalOrderNumber for services (example M001)
			if (!self.isMService(item.internalItem || item.item)) {
				item.originalOrderNumber = newPayload.orderNumber;
			}
			// if SDS Will Call is selected, we should send all items as Crated
			if (newPayload.deliveryMethod === 'SDS Will Call') {
				item.uncrateInd = 'N';
			}
			// pass same requestedDeliveryDate for all the lines in new order
			item.requestedDeliveryDate = rdd;
		});
		// set selected delivery method
		newPayload.deliveryMethod = self.state.deliveryMethod;
		newPayload.requestedDeliveryDate = rdd;

		const payload = JSON.parse(JSON.stringify(self.state.payload));
		const remainingItems = [];
		payload.items.forEach(item => {
			if (item.lineType === 'Split Delivery') {
				// if item is reserved
				if (parseInt(item.reserved, 10) === parseInt(item.quantity, 10)) {
					// Do nothing: (Those will be cancelled automatically by the concurrent job that transfers the reservations.)
				} else {
					// cancel the lines on the original order that were Split, except for lines that were reserved
					remainingItems.push({
						...item,
						action: 'cancel'
					});
				}
			} else {
				remainingItems.push(item);
			}
		});

		// this new payload for split delivery
		self.setState({
			payload: {
				...payload,
				items: remainingItems
			},
			newPayload,
		}, () => {
			self.handleDialog('ChangeRequestedDeliveryDateOverlayDialog', false);
			self.continueWithPreparedPayload();
		});
	}

	validateSubstituteCriteria(item) {
		const self = this;
		let flag = false;
		const rdd = self.state.updateBookedOrderDetails.requestedDeliveryDate;
		const ead = item.expectedAvailableDate && moment(item.expectedAvailableDate);
		if (rdd && ead) {
			// The order RDD is <= 16 days from today.
			const todayPlus16 = moment().add(16, 'day');
			// The Expected Available Date (Suggested ship date) is > the RDD
			if (moment(rdd).isSameOrBefore(todayPlus16) && ead.isAfter(rdd)) {
				flag = true;
			}
		}
		return flag;
	}

	render() {
		const self = this;
		const { deliveryMethod, updateBookedOrderDetails, selectedPriceSource, anyHoldBackOrderItem, anyReservationTransferHold, suggstionList } = self.state,
			{ allowedCustomerClassCodes } = self.props.state.order,
			{ selectedAccount } = self.props.state.user,
			customerClassCode = selectedAccount && selectedAccount.CUSTOMERCLASSCODE ? selectedAccount.CUSTOMERCLASSCODE.toLowerCase() : "",
			typeOfAccount = self.props.getSelectedAccountType();
		let orderDate = '',
			poNumber = '',
			deliveryInstructions = '',
			deliveryPhone = '',
			cancelable = false,
			updatable = false,
			allUpdatable = false,
			allCancelable = false;
		if(updateBookedOrderDetails) {
			poNumber = updateBookedOrderDetails.poNumber;
			deliveryPhone = updateBookedOrderDetails.deliveryPhone;
			deliveryInstructions = updateBookedOrderDetails.deliveryInstructions;
			orderDate = updateBookedOrderDetails.orderDate && this.props.formatDate(updateBookedOrderDetails.orderDate, 'MM/DD/YYYY');
			allCancelable = updateBookedOrderDetails.items.find(itm => itm.cancelable !== 'Yes' && itm.lineId) ? false : true;
			allUpdatable = updateBookedOrderDetails.items.find(itm => itm.updatable !== 'Yes' && itm.lineId) ? false : true;
			cancelable = updateBookedOrderDetails.cancelable == 'Yes' ? true :false;
			updatable = updateBookedOrderDetails.updatable == 'Yes' ? true :false;
		}

		let subCustomerClasification = '';
		let selectedAccountsAllPriceSources = [];
		if(selectedPriceSource && selectedPriceSource.AGREEMENT_NUMBER) {
			selectedAccountsAllPriceSources = self.props.getSalesAgreementList(selectedPriceSource.AGREEMENT_NUMBER);
		}
		if(selectedPriceSource && selectedPriceSource.AGREEMENT_NUMBER && selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject && selectedAccountsAllPriceSources.responseObject.length > 0) {
			const data = selectedAccountsAllPriceSources.responseObject.find(item => item.AGREEMENT_NUMBER === parseInt(selectedPriceSource.AGREEMENT_NUMBER, 10));
			subCustomerClasification = data && data["Sub Account Classification"] ? data["Sub Account Classification"].toLowerCase() : '';
		}
		const isViewOrdersAccess = self.props.isResponsibilityExists("View Orders");
		const isFedExGround = updateBookedOrderDetails && updateBookedOrderDetails.deliveryMethod === 'FedEx Ground' ? true : false;
        return (
			<div>
				<h1 className="pageTitle">Update Booked Order</h1>
				<p>
					<a href="" onClick={this.redirectToPreviousPage}>Return to Previous Screen</a>
				</p>
				<p className="orange">Products that are already shipping cannot be cancelled or split from this order.  Please allow 30 min for changes to be reflected on orders.</p>
				<p className="red bold">{self.state.errorMessage}</p>
				{self.state.disallowSAErrorMessage && <p className="red bold">{self.state.disallowSAErrorMessage}</p>}
				<p className="netOrderPoints"><strong>Order Points:</strong> {updateBookedOrderDetails && updateBookedOrderDetails.orderPoints} &nbsp; &nbsp; &nbsp; <strong>Order Weight:</strong> {updateBookedOrderDetails && updateBookedOrderDetails.orderWeight}</p>
				<div className="captionAboveTable" style={{marginTop: 0}}>
					<div className="bold big">
						CSO: {updateBookedOrderDetails && updateBookedOrderDetails.orderNumber} &nbsp; &nbsp; &nbsp; 
						Order Date: {orderDate} &nbsp; &nbsp; &nbsp; 
						P.O. #: {self.state.poNumberValue} &nbsp; &nbsp; &nbsp; 
						{updateBookedOrderDetails && updateBookedOrderDetails.deliveryMethod.toUpperCase()} &nbsp; &nbsp; &nbsp; 
						Warehouse: {updateBookedOrderDetails && updateBookedOrderDetails.warehouseCode} <br/>
						Delivery Phone:&nbsp; <input id="deliveryPhone" style={{width:"125px"}} onBlur={this.onBlurValidatePhoneNumber.bind(this)} value={self.state.deliveryPhoneValue} type="text" name="deliveryPhone" onChange={this.onChangeUpdateParamHeaderFields.bind(this)} maxLength={10} />  &nbsp; &nbsp;
						Shipping Instructions:&nbsp; <textarea maxLength={300} rows={1} cols={50} name="deliveryInstructions" onChange={this.onChangeUpdateParamHeaderFields.bind(this)} value={self.state.deliveryInstructionsValue} />
					</div>
				</div>
				{updateBookedOrderDetails &&
					<table id="tbl--manageOrders" className="dataTable manageOrdersDeleteProductsTable" width="100%">
						<thead>
							<tr>
								<th>Product</th>
								<th>Price Info</th>
								<th>Quantity<br />Ordered</th>
								<th>Reserved</th>
								<th>Expected Available<br />Date</th>
								<th>PO</th>
								<th>Action</th>
								<th>Crate /<br />Uncrate</th>
								{updateBookedOrderDetails.deliveryMethod === 'SDS Delivery' || updateBookedOrderDetails.deliveryMethod === 'SDS Delivery Next Day'
									?<th>Add<br/>Services</th>
									:null
								}
							</tr>
						</thead>
						<tbody>
							{updateBookedOrderDetails && updateBookedOrderDetails.items.map((item, index) => {
								let searchKeywordObjectOverPack = self.state.searchKeywordItem.find((searchItem)=>searchItem.sku === item.item) || item;
								let optionOverPackValues = [];
									if(searchKeywordObjectOverPack && searchKeywordObjectOverPack.overpackQuantityRequired && (searchKeywordObjectOverPack.overpackQuantityRequired === "1" || searchKeywordObjectOverPack.overpackQuantityRequired.toLowerCase() === "true" || searchKeywordObjectOverPack.overpackQuantityRequired.toLowerCase() === "yes") ){
										if(searchKeywordObjectOverPack.packageQuantity && searchKeywordObjectOverPack.packageQuantity > 1){
											optionOverPackValues[0]= "select";
											for(let i=1 ; i<=20 ; i++){
												optionOverPackValues[i] = (searchKeywordObjectOverPack.packageQuantity * (i));
											}
										}
									}
								let lifeCyclePhase = item && item.lifeCyclePhase  && item.lifeCyclePhase === "Near End of Life" ? true : false;
								const reservationTransferLine = item.holds && item.holds.hold && item.holds.hold.find(itm => itm.holdName === 'Reservation Transfer Line') ? true : false;
								const itemLevelDisableUncrateDropdown = (allowedCustomerClassCodes.indexOf(customerClassCode) !== -1 || typeOfAccount === "RETAIL")
									&& item.uncrateInd === 'N' ? true : false;
								return [
									<tr key={index} className={(index === this.state.selectedSKUIndex?'highlight-row':'')}>
										<td>
											{item.internalItem || item.item}
											{self.props.isAnyModelIsRestrictedInSelectedAccount(item) && <p className="red">Please remove the highlighted model. GEA is not currently selling this model to this account.</p>}
										</td>
										<td>
											<a className="priceSource" onClick={this.handlePriceSourceDialog.bind(this, item.agreementNumber, "PriceSourceOverlayDialog", true, item)} href="">$</a>
										</td>
										<td>
										{item.action === 'reduceQty' && optionOverPackValues.length == 0
												?<input type="text" 
												onKeyPress={this.props.acceptNumbersOnly} 
												className={`updatebookedorder-quantity ${item.quantityError}`} 
												name="updatedQuantity" 
												onChange={this.onChangeUpdateParam.bind(this, index)} 
												defaultValue={item.updatedQuantity} />
												:null
											}
											{item.whenAdded !== 'new' && item.action === 'reduceQty' && optionOverPackValues.length > 0
											?<td className="quantity">
												<select className={`updatebookedorder-quantity ${item.updatedQuantityError}`} name="updatedQuantity" 
												 onChange={this.onChangeUpdateParam.bind(this, index)} defaultValue={item.updatedQuantity}>
														{optionOverPackValues.map((val, index)=>{
																return <option 
																		id={"quantity"+index}
																		key={index} 
																		value={val}>{val}</option>
															}) }
													</select>
											</td>
											:null
											}
											{item.whenAdded === 'new'&& item.overpackQuantityRequired
											?<td className="quantity">
												<select className={`updatebookedorder-quantity ${item.updatedQuantityError}`} name="quantity" 
												 onChange={this.onChangeUpdateParam.bind(this, index)} defaultValue={item.quantity}>
														{optionOverPackValues.map((val, index)=>{
																return <option 
																		id={"quantity"+index}
																		key={index} 
																		value={val}>{val}</option>
															}) }
													</select>
													</td>
											:item.action === 'reduceQty'?""
											:item.whenAdded == "new" && optionOverPackValues.length == 0 && item.action !== 'reduceQty' ?
											<input type="text" 
												onKeyPress={this.props.acceptNumbersOnly} 
												className={`updatebookedorder-quantity ${item.quantityError}`} 
												name="quantity" 
												onChange={this.onChangeUpdateParam.bind(this, index)} 
												defaultValue={item.quantity} />
											:<span>{item.quantity}</span>}
											<p className="red bold">{item.quantityGTError}</p>
											{item.quantityError && parseInt(item.quantity, 10) > parseInt(item.availability, 10) &&<p className="red bold">Quantity can not be greater than available quantity.</p>}
										</td>
										<td>{(item.lineStatus && item.lineStatus.toLowerCase() == ("closed")) || (item.lineStatus && item.lineStatus.toLowerCase() == ("awaiting fulfillment")) || ((updateBookedOrderDetails.deliveryMethod === 'SDS Delivery' || updateBookedOrderDetails.deliveryMethod === 'SDS Will Call') &&  (item.lineStatus && item.lineStatus.toLowerCase() == ("picked"))) ? "": (!self.isMService(item.internalItem || item.item) && item.reserved)}</td>
										<td>
										{ lifeCyclePhase? <p className="red bold">NLA</p> : ((item.updatable == "Yes" && item.cancelable == "Yes") && (item.reserved != item.quantity) ? item.expectedAvailableDate : "")}
										</td>
										<td>
											{item.whenAdded === 'new' &&
												<input type="text" onPaste={this.manipulateClipBoardOfPONumber.bind(this, index, 'new')} maxLength={50} name="poNumber" onKeyPress={this.validatePONumberCharactersItemLevel.bind(this, index)} onChange={this.onChangeUpdateParam.bind(this, index)} value={item.poNumber}/>}
											{item.whenAdded !== 'new' &&
												<input type="text" onPaste={this.manipulateClipBoardOfPONumber.bind(this, index, 'old')} maxLength={50} name="poNumber" onKeyPress={this.validatePONumberCharactersItemLevel.bind(this, index)} onChange={this.onChangeUpdateParam.bind(this, index)} value={item.poNumber} disabled={!(item.updatable === 'Yes') || reservationTransferLine} />}
											{item.invalidPONumberItemLevel && <p className="bold red">{this.state.invalidPONumberMessage}</p>}
										</td>
										<td>
											{item.whenAdded === 'new'
												?<select className={item.actionError} onChange={this.handleSelectAction.bind(this, index, item)}>
													<option value="">Select Action</option>
													{item.itemType !== 'S' && selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject
														&& selectedAccountsAllPriceSources.responseObject.length > 1 && !lifeCyclePhase &&
														<option value="P">Sales Agreement</option>
													}
													<option value="D">Delete</option>
													{item.itemType !== 'S' && typeOfAccount === "RETAIL" && item.hasUpgrade && <option value="U">Upgrade</option>}
													{item.itemType !== 'S' && item.availability === 0 && (typeOfAccount === "CONTRACT" || typeOfAccount === "PRO CHANNEL" || typeOfAccount === "HQ") && self.props.isValidClassificationCodeForSubstitute(subCustomerClasification) && self.props.isValidClassificationCodeForSubstitute(customerClassCode) && item.hasSubstitute && <option value="S">Substitute</option>}
													{item.itemType !== 'S' && item.hasReplacement && <option value="R">Replace</option>}
													{/*item.itemType !== "S" && item.availability === 0 && <option value="H">Hold Backorder</option>}
													{item.itemType !== "S" && item.availability === 0 && <option value="F">Force Backorder</option>*/}
												</select>
											:(item.updatable == "Yes" && item.cancelable == "Yes")?<select onChange={this.onChangeUpdateParam.bind(this, index)} name="action" defaultValue={item.action} id="actionOption1" className={`sel--action ${item.action && item.action !== 'update' ? 'red' : ''}`} disabled={!(item.updatable === 'Yes') || reservationTransferLine}>
													<option value="" className="black">Select Action</option>
													{!lifeCyclePhase && <option value={'cancel'} className={item.action === 'cancel' ? 'red' : 'black'}>Cancel</option>}
													{!lifeCyclePhase && <option value={'reduceQty'} className={item.action === 'reduceQty' ? 'red' : 'black'}>Reduce Qty</option>}
													{/* WCP-7479: roll back
													item.itemType !== "S"
														&& self.props.isValidClassificationCodeForSubstitute(subCustomerClasification)
														&& self.props.isValidClassificationCodeForSubstitute(customerClassCode)
														&& (item.quantity > item.reserved)
														&& item.hasSubstitute
														&& self.validateSubstituteCriteria(item)
														&& <option value="substitute">Substitute</option>
													*/}
													{!lifeCyclePhase && !(item.reserved > 0) && !isFedExGround && !anyHoldBackOrderItem && !self.isMService(item.internalItem || item.item) && <option value={'Hold Backorder'} className={item.action === 'Hold Backorder' ? 'red' : 'black'}>Hold Backorder</option>}
													{!lifeCyclePhase && !anyReservationTransferHold && (updateBookedOrderDetails.deliveryMethod === 'SDS Delivery' || updateBookedOrderDetails.deliveryMethod === 'SDS Will Call') && <option value={'Split Delivery'}>Split Delivery</option>}
												</select>:""
											}
										</td>
										<td>
											{item.whenAdded !== 'new' && !self.isMService(item.internalItem || item.item)
												? (
													item.uncrateInd &&
														(item.uncrateInd === 'Y'
															? 'Uncrated'
															: 'Crated'
														)
												)
												: null
											}
											{item.whenAdded === 'new' && item.itemType !== 'S' && <select
												name="uncrateInd"
												onChange={this.onChangeUpdateParam.bind(this, index)}
												defaultValue={item.uncrateInd}
												disabled={itemLevelDisableUncrateDropdown}
											>
												<option value="N">Crated</option>
												<option value="Y">Uncrated</option>
											</select>}
										</td>
										{updateBookedOrderDetails.deliveryMethod === 'SDS Delivery' || updateBookedOrderDetails.deliveryMethod === 'SDS Delivery Next Day'
											?<td className="services">
												{(item.itemType === 'M' || item.itemType === 'A') && (!itemLevelDisableUncrateDropdown || (itemLevelDisableUncrateDropdown && item.uncrateInd === "Y"))
													?<a className="servicesLink" onClick={this.handleAddServices.bind(this, index, item.item, itemLevelDisableUncrateDropdown)} href="">
														<img className="icon" src="../images/icon-services-large.png" width={27} height={27} alt="Add Services" title="Add Services" />
													</a>
													:null
												}
											</td>
											:null
										}
									</tr>,
									item.relatedServices?
										item.relatedServices.map((itm, ind) => {
											if(itm.type === "BAG") return null;
											return <tr key={ind}>
												<td className="product">
													&nbsp; &nbsp; {itm.serviceId}
												</td>
												<td className="priceSource">
													<a className="priceSource m-auto" onClick={this.handlePriceSourceDialog.bind(this, item.agreementNumber, "PriceSourceOverlayDialog", true, item)} href="">$</a>
												</td>
												<td className="quantity">
													<input type="text" id={"servicequantity"+ind} className={`itemQuantity ${itm.quantityError}`} onKeyPress={this.props.acceptNumbersOnly} value={itm.quantity} onChange={this.handleChangeQuantityService.bind(this, index, itm.serviceId)} defaultValue={item.quantity} size={1} />
												</td>
												<td></td>
												<td className="availability"></td>
												<td className="poNumber" />
												<td className="action">
													<select name={"action_XXXXXXXXXXX"+ind} onChange={this.handleActionChangeService.bind(this, index, itm.serviceId)}>
														<option value="">Select Action</option>
														<option value="D">Delete</option>
													</select>
												</td>
												<td className="delCrate"></td>
												{updateBookedOrderDetails.deliveryMethod === 'SDS Delivery' || updateBookedOrderDetails.deliveryMethod === 'SDS Delivery Next Day'
													?<td className="services"></td>
													:null
												}
											</tr>
										}):
									null
								]
							})}
							{this.state.products.map((item, index) => {
								if(!item) return null;
								if(item.productDetails && item.productDetails.lifeCyclePhase === "Near End of Life"){
									item.error = 'error'
								}
								let lifecyclePhaseValue = item.productDetails && item.productDetails.lifeCyclePhase;
								return <tr key={index}>
									<td className={"product " + item.error}>
										<AccountNumberAutoSuggests
											checkAvailabilityAndOrderability={this.props.checkAvailabilityAndOrderability}
											selectedAddressParams={this.getSelectedAddressParams()}
											selectedPriceSource={self.state.selectedPriceSource.AGREEMENT_NUMBER}
											getShippingAddressesDetails={this.props.getShippingAddressesDetails}
											width="auto"
											size={8}
											updateQuickOrderState={this.updateQuickOrderState.bind(this)}
											onChangeProductNumberTextBox={this.handleChangeProductNumberTextBox.bind(this)}
											itemIndex={index}
											legacyCustCode={self.props.getLegacyCustCode()}
											zipCode={self.getZipCode()}
											doNotSelectHeaderSelectedADC={ true }
											getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
										/>
										{(item.productDetails && item.productDetails.status === false) || (item.productDetails)
											?<span className="quickOrderTableRowError">You must enter a valid full or partial product number.</span>
											:null
										}
										{item.modelNotAvailableError && <p className="red bold">Model is not available before the Request Date and cannot be added.</p>}
										{lifecyclePhaseValue === "Near End of Life" && <span className="quickOrderTableRowError"><p className="red bold">Model is not available please add diffrent item</p></span>}
									</td>
									<td className="priceSource">
										{ item.agreementNumber && <a className="priceSource" onClick={this.handlePriceSourceDialog.bind(this, item.agreementNumber, "PriceSourceOverlayDialog", true, item)} href="">$</a>}
									</td>
									<td className="quantity">{ item.productDetails && item.productDetails.lifeCyclePhase === "Near End of Life" ? "" : item.quantity}</td>
									<td></td>
									<td className="availability">
										{item.productDetails && item.productDetails.availableQty }<br/>
										{item.productDetails && self.props.formatETADate(item.productDetails.etaDate)}
									</td>
									<td className="poNumber">
										<input type="text" maxLength={50} onPaste={this.manipulateClipBoardOfPONumber.bind(this, index, 'new')} name="poNumber" onChange={this.onChangeUpdateParamForNewProduct.bind(this, index)} defaultValue={item.poNumber} />
									</td>
									<td className="action">
										<select onChange={this.handleSelectActionAddedProducts.bind(this, index)}>
											<option value="">Select Action</option>
											<option value="D">Delete</option>
										</select>
									</td>
									<td className="delCrate">
										<select onChange={this.onChangeUpdateParamForNewProduct.bind(this, index)} name="uncrateInd">
											<option value="N">Crated</option>
											<option value="Y">Uncrated</option>
										</select>
									</td>
									<td></td>
								</tr>
							})}
						</tbody>
					</table>
				}
				{updateBookedOrderDetails && <div className="clearfix">
					{!isFedExGround && updateBookedOrderDetails.deliveryMethod !== 'ADC Velocity' && !anyReservationTransferHold && <div style={{float: 'left'}}>
					{allUpdatable && !anyHoldBackOrderItem && updateBookedOrderDetails.updatable == "Yes" && <p>
							<strong>Forget something? <a href="#" id="a--addLineItem" onClick={this.handleMoreLines.bind(this)}>+ ADD</a></strong>
						</p>}
						{!self.isScheduledArrivalDateIsGreaterThan8Days(updateBookedOrderDetails.items) && isViewOrdersAccess && allUpdatable && !anyHoldBackOrderItem && (self.props.state.order.isBackOrdersAvailable || self.props.state.order.isBulkOrdersHoldAvailable)  && updateBookedOrderDetails.updatable == "Yes" && <p>
							<strong><a href="#" id="a--addLineItem" onClick={this.showBackOrdersBlock.bind(this)}>+ ADD AVAILABLE BACKORDERS</a></strong>
						</p>}
					</div>}
					{!isFedExGround && updateBookedOrderDetails.deliveryMethod !== 'ADC Velocity' && this.state.showBackOrders &&
						<div style={{width: '100%', float: 'right'}}>
							<BackOrdersAvailable
								{...self.props}
								updateOrderPoints={this.updateOrderPoints}
								checkIfStateIsAk={self.checkIfStateIsAk}
								zipCode={self.getShippingAddressZipCode()}
								getElementOffset={self.getElementOffset}
								selectedAddressParams={self.getSelectedAddressParams()}
								deliveryMethod={updateBookedOrderDetails.deliveryMethod}
								warehouseCodeADC = {updateBookedOrderDetails.warehouseCode}
								shippingAddressState={self.getShippingAddressState()}
							/>
						</div>
					}
					<div style={{float: 'right', textAlign: 'right'}}>
					<span><a className="blueButton blockButton deleteSelectedProducts" onClick={this.handleSaveAndContinue.bind(this)} href="">Save &amp; Continue</a></span>
						{allCancelable && <h3>OR</h3>}
						{allCancelable &&
							<span><a onClick={this.handleCancelEntireOrder.bind(this)} className="blueButton blockButton deleteEntireOrder" href="">Cancel Entire Order</a></span>
						}
					</div>
				</div>}
				{this.state.showSubstituteProductOverlayDialog && this.state.substituteSKUData?
					<SubstituteProductOverlayDialog resetSelectedSKU={this.resetSelectedSKU} selectedRDD={this.state.selectedRDD} handleUpgradeItem={this.handleUpgradeItem.bind(this)} substituteSKUData={this.state.substituteSKUData} sku={this.state.selectedSKU} handleDialog={this.handleDialog} showDialog={true} />
				:null }
				{this.state.showReplaceProductOverlayDialog && this.state.replacementSKUData?
					<ReplaceProductOverlayDialog resetSelectedSKU={this.resetSelectedSKU} handleReplace={this.handleReplace.bind(this)} replacementSKUData={this.state.replacementSKUData} handleDialog={this.handleDialog} showDialog={true} />
				:null }
				{this.state.showUpgradeProductOverlayDialog && this.state.upgradeSKUData?
					<UpgradeProductOverlayDialog resetSelectedSKU={this.resetSelectedSKU} handleUpgradeItem={this.handleUpgradeItem.bind(this)} upgradeSKUData={this.state.upgradeSKUData} sku={this.state.selectedSKU} handleDialog={this.handleDialog} showDialog={true} />
				:null }
				{this.state.showAddServicesOverlayDialog && this.state.availableServices?
					<AddServicesOverlayDialog
						availableServices={this.state.availableServices}
						resetSelectedSKU={this.resetSelectedSKU}
						handleSelectedServices={this.handleSelectedServices.bind(this)}
						handleDialog={this.handleDialog}
						itemLevelDisableUncrateDropdown={this.state.itemLevelDisableUncrateDropdown}
						selectedSKU={this.state.selectedSKU}
						selectedSKUIndex={this.state.selectedSKUIndex}
						formatAmount2Decimal={this.props.formatAmount2Decimal}
						items={this.state.updateBookedOrderDetails.items}
						getPIMItemInfo={this.props.getPIMItemInfo}
						showDialog={true}
						requiredPayloadForServicePricing={this.state.requiredPayloadForServicePricing}
					/>
				:null }
				{this.state.showSelectPriceSourceOverlayDialog
					? <SelectPriceSourceOverlayDialog
						selectedPriceSource={this.state.selectedPriceSourceForUpdate}
						changeSelectedPriceSource={this.changeSelectedPriceSource.bind(this)}
						handleDialog={this.handleDialog}
						selectedAccountsAllPriceSources={selectedAccountsAllPriceSources}
						showDialog={true}
					/>:null
				}
				{this.state.showPriceSourceOverlayDialog?<PriceSourceOverlayDialog
					selectedItem={this.state.selectedItem}
					orderDate={orderDate}
					selectedAccountsAllPriceSources={this.props.state.user.selectedAccountsAllPriceSources}
					priceSource={this.state.selectedPriceSourceForUpdate}
					showDialog={true}
					handleDialog={this.handleDialog}
					isResponsibilityExists={this.props.isResponsibilityExists}
					formatMoney={this.props.formatMoney}
					typeOfAccount={this.props.getSelectedAccountType()}
				/>:null}
				{this.state.showInvalidSalesAgreementOverlayDialog?<InvalidSalesAgreementOverlayDialog invalidSAItems={this.state.invalidSAItems} handleDialog={this.handleDialog} showDialog={true} />:null}
				{this.state.showGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showCancelEntireOrderConfirmationOverlaydialog?<GenericOverlayDialog flag={'CancelEntireOrderConfirmationOverlaydialog'} handleYes={this.handleDelete.bind(this)} genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons={this.state.modalButtons} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showChangeShippingMethodOverlayDialog?<ChangeShippingMethodOverlayDialog isAnyMServiceSelectSplitDelivery={this.state.isAnyMServiceSelectSplitDelivery} isSDS_LOC={this.state.isSDS_LOC} isSDS_will_call_loc={this.state.isSDS_will_call_loc} deliveryMethod={updateBookedOrderDetails.deliveryMethod} changeDeliveryMethod={this.changeDeliveryMethod.bind(this)} showDialog={true} />:null}
				{this.state.showChangeRequestedDeliveryDateOverlayDialog?<ChangeRequestedDeliveryDateOverlayDialog flag={'ChangeRequestedDeliveryDateOverlayDialog'} fromWhichPage="bookedOrder" callBackAfterRDDUpdate={this.callBackAfterRDDUpdate.bind(this)} orderDetail={updateBookedOrderDetails} pickTheDateFromString={this.props.pickTheDateFromString} deliveryCalendar={this.state.deliveryCalendar} isWeekday={this.props.isWeekday} shippingMethod={deliveryMethod || updateBookedOrderDetails.deliveryMethod} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	deleteOrderDetails: (payload, queryStringParams, showLoader, callback) => dispatch(deleteOrderDetails(payload, queryStringParams, showLoader, callback)),
	saveUpdateBookedOrderConfirmationPageData: (data) => dispatch(saveUpdateBookedOrderConfirmationPageData(data)),
	saveDeletedOrderProductsDetails: (deletedOrderObj) => dispatch(saveDeletedOrderProductsDetails(deletedOrderObj)),
	getPIMItemInfo: (payload, params, response) => dispatch(getPIMItemInfo(payload, params, response)),
	checkPricesForSearchResult: (data, showLoader, saveToStore, callback) => dispatch(checkPricesForSearchResult(data, showLoader, saveToStore, callback)),
	updateBookedOrder: (payload, params, response) => dispatch(updateBookedOrder(payload, params, response)),
	getOrderableServices: (payload, params, response) => dispatch(getOrderableServices(payload, params,response)),
	checkServicePrices: (payload, params, response) => dispatch(checkServicePrices(payload, params, response)),
	addToCart: (payload, callback) => dispatch(addToCart(payload, callback)),
	saveToCart: (data) => dispatch(saveToCart(data)),
	decliningBalance: (params, callback) => dispatch(decliningBalance(params, callback)),
	saveBackOrders: (data) => dispatch(saveBackOrders(data)),
	saveBulkOrdersHold: data => dispatch(saveBulkOrdersHold(data)),
	saveOrderableServices: (data) => dispatch(saveOrderableServices(data)),
	createNewOrder: (payload, params, useBootApi, response) => dispatch(createNewOrder(payload, params, useBootApi, response)),
	getSearchKeywordSuggestionList: (payload, callback, showloader) => dispatch(getSearchKeywordSuggestionList(payload, callback, showloader)),
	getOrderDetails: (queryStringParams, callback) => dispatch(getOrderDetails(queryStringParams, callback)),
	getDeliveryCalendar: (payload, queryString, showLoader, callback) => dispatch(getDeliveryCalendar(payload, queryString, showLoader, callback))
})

updateBookedOrderForm = connect(mapStateToProps, mapDispatchToProps)(updateBookedOrderForm);
export default updateBookedOrderForm;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/updateBookedOrder.js